var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJosefinSansVariableFontWght(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Wed Aug  4 17:12:24 2021\n By www-data\nCopyright 2010 The Josefin Sans Project Authors (https://github.com/ThomasJockin/JosefinSansFont-master), with Reserved Font Name \"Josefin Sans\".\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "JosefinSansVariableFont_wght",
    horizAdvX: 0
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "JosefinSansVariableFont_wght",
    fontWeight: 100,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 750,
    descent: -250,
    xHeight: 378,
    capHeight: 702,
    bbox: "-74 -233 1364 1096",
    underlineThickness: 50,
    underlinePosition: -125,
    unicodeRange: "U+000D-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 571,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM396 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2 q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 494,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h129v-18h-129v-357h-20zM381 378h19v-378h-19v378zM369 497q0 9 6.5 15.5t15.5 6.5t16 -6.5t7 -15.5t-7 -15.5t-16 -6.5t-15.5 6.5 t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 494,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h129v-18h-129v-357h-20zM381 752h19v-752h-19v752z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 779,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM396 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2 q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM665 378h20v-378h-20v378zM653 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 779,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM396 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2 q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM665 752h20v-752h-20v752z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CR",
    unicode: "\r",
    horizAdvX: 301
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 301
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 201,
    d: "M91 751h18v-583h-18v583zM101 33q-10 0 -17.5 7t-7.5 18q0 10 7.5 17t17.5 7t17 -7t7 -17q0 -11 -7 -18t-17 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 296,
    d: "M86 721q-1 -63 -2.5 -124.5t-1.5 -124.5h-19v249h23zM219 721q-1 -63 -2 -124.5t-2 -124.5h-19v249h23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 572,
    d: "M214 644q-6 -55 -13 -110t-13 -110h165q6 55 13 110l14 110h19l-14 -110t-13 -110h133q0 -5 -0.5 -9.5t-0.5 -9.5h-135q-5 -41 -9.5 -82t-9.5 -82h133q-1 -5 -1.5 -9t-0.5 -9h-134q-6 -56 -12.5 -111.5t-12.5 -111.5h-19q6 56 12.5 111.5t12.5 111.5h-165 q-7 -56 -13 -111.5t-13 -111.5h-19q7 56 13 111.5t13 111.5h-115q0 5 0.5 9t0.5 9h117q5 41 9.5 82t9.5 82h-114q0 5 0.5 9.5t0.5 9.5h116q6 55 13 110t13 110h19zM185 405q-5 -41 -9.5 -82t-9.5 -82h165q5 41 9.5 82t9.5 82h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 567,
    d: "M276 -68v448v8v378h18v-383v-8v-443h-18zM447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18 q21 -15 53 -31.5t70.5 -28t78.5 -11.5q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 732,
    d: "M219 223q-31 0 -56.5 16.5t-40.5 48.5t-15 77q0 44 15 75.5t40.5 48t56.5 16.5t56.5 -16.5t40.5 -48t15 -75.5q0 -46 -15.5 -77.5t-41 -48t-55.5 -16.5zM126 364q0 -60 27 -92t66 -32t66 32t27 92q0 57 -27 90.5t-66 33.5t-66 -31t-27 -93zM527 3q-31 0 -56.5 16.5 t-40.5 48t-15 76.5q0 44 15 75.5t40.5 48t56.5 16.5t56.5 -16.5t40.5 -48t15 -75.5q0 -46 -15.5 -77.5t-41 -47.5t-55.5 -16zM434 143q0 -59 27 -91.5t66 -32.5t66.5 32.5t27.5 91.5q0 57 -27.5 90.5t-66.5 33.5t-66 -31t-27 -93zM533 508l-306 -508h-22l307 508h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 702,
    d: "M605 0h-4.5h-8h-8h-3.5l-383 494q-8 14 -15.5 29.5t-12 33.5t-4.5 40q0 45 21 79.5t57 53.5t79 19q41 0 76 -14.5t60 -30.5l-9 -14q-30 18 -61.5 29.5t-63.5 11.5q-59 0 -98.5 -36.5t-39.5 -94.5q0 -26 7 -48t14.5 -35l7.5 -13zM300 369q-35 -1 -70.5 -14t-65.5 -37 t-48 -57.5t-18 -74.5q0 -52 28 -91t74 -61t102 -22q46 0 87 15t71 40t44 54l12 -18q-25 -47 -84 -78t-131 -31q-67 0 -117.5 26t-79.5 70t-29 97q0 43 18 78.5t49.5 62.5t71 42t82.5 17zM603 387h22l-107 -282l-14 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 148,
    d: "M88 721q-1 -63 -2 -124.5t-2 -124.5h-19v249h23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 395,
    d: "M144 292q0 100 23.5 187t61.5 155.5t80 113.5l8 -25q-39 -44 -74 -108.5t-57 -146t-22 -176.5t22 -176.5t57 -146t74 -108.5l-8 -24q-42 44 -80 112.5t-61.5 155.5t-23.5 187v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 400,
    d: "M281 292q0 -100 -23.5 -187t-61.5 -155.5t-80 -112.5l-8 24q39 44 74 108.5t57.5 146t22.5 176.5t-22.5 176.5t-57.5 146t-74 108.5l8 25q42 -45 80 -113.5t61.5 -155.5t23.5 -187v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 335,
    d: "M157 559q-27 -16 -54 -31.5t-54 -30.5q-3 4 -5.5 8.5t-5.5 8.5q28 16 55 31.5t54 30.5q-27 16 -54 32.5t-54 32.5q1 3 3.5 7t4.5 7q27 -16 54.5 -31.5t55.5 -31.5v128h21q-1 -32 -1.5 -64t-0.5 -64q28 15 56 31t56 31q1 -3 3.5 -7t4.5 -7q-28 -16 -55.5 -32.5 t-55.5 -32.5v0q27 -16 55 -31.5t55 -31.5q-3 -4 -5.5 -8.5t-5.5 -8.5l-54 32l-54 32q-1 -31 -1.5 -62t-0.5 -63h-17v125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 544,
    d: "M257 411h19v-169h170v-19h-170v-172h-19v172h-171v19h171v169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 184,
    d: "M132 86q-22 -52 -43 -103t-43 -103h-18q19 52 38 103t39 103h27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 300,
    d: "M53 202h184v-19h-184v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 186,
    d: "M71 22q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 326,
    d: "M314 737q-70 -189 -139 -378t-139 -378h-19q70 189 139 378t139 378h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 617,
    d: "M308 -6q-67 0 -118 27.5t-85.5 74.5t-51.5 106.5t-17 123.5t17 123t51.5 105.5t85.5 73.5t118 27q68 0 119 -27t85 -74t51.5 -106t17.5 -122q0 -64 -17.5 -123.5t-51.5 -106.5t-85 -74.5t-119 -27.5zM308 13q71 -1 128 36.5t90.5 107.5t34.5 168q-1 97 -34.5 167 t-90.5 107.5t-128 36.5q-70 1 -127 -36.5t-90.5 -107.5t-34.5 -167q1 -98 34.5 -168t90.5 -107.5t127 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 308,
    d: "M59 651h131v-651h-20v631h-111v20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 496,
    d: "M53 0q64 62 124 122.5t108 119t75.5 114t27.5 107.5q0 50 -15 84.5t-39 54.5t-51.5 29t-52.5 9q-48 0 -79.5 -17t-49.5 -43.5t-25 -56t-7 -54.5q0 -36 10 -64.5t29 -49.5l-12 -11q-14 16 -24.5 34.5t-16.5 40.5t-6 49q0 54 21 97t61.5 68.5t99.5 25.5q53 0 93 -25.5 t62 -69.5t22 -100q0 -58 -29.5 -115.5t-77.5 -114.5t-103.5 -113t-106.5 -109l-5 7h367v-19h-400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 518,
    d: "M406 651l-225 -276l-16 2q18 11 41 16.5t49 5.5q40 2 75 -9t62 -34.5t42 -59t15 -81.5q0 -66 -29 -116.5t-79.5 -78.5t-116.5 -28q-45 0 -84 18t-66 48l10 15q24 -28 61.5 -45t78.5 -17q61 0 107 26t72 72.5t26 106.5q0 77 -48.5 121.5t-128.5 44.5q-27 0 -54 -7t-45 -17 l-4 3l225 278l3 -7h-291v19h320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 506,
    d: "M23 181v1l368 477h1v-460h96v-18h-96v-181h-20v181h-349zM375 609l-319 -413l-5 3h321v420z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 543,
    d: "M254 -8q-42 0 -78.5 15t-64.5 42l13 13q24 -24 57 -38t70 -14q53 0 95.5 26t68 68t25.5 92q0 51 -25 92.5t-67 66.5t-95 25q-35 0 -64.5 -12t-47.5 -28h-1v311h289v-19h-270v-266l-6 6q19 12 48 19t56 7q57 -1 103 -27.5t73 -72.5t27 -102t-28 -102.5t-74.5 -74 t-103.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 520,
    d: "M255 -8q-57 0 -103.5 27.5t-74.5 74t-28 103.5q0 76 30.5 140.5t79.5 118.5t107 100.5t113 87.5l13 -17q-84 -56 -146 -111.5t-101 -109t-54 -102.5l-6 3q28 44 74.5 67t98.5 23q56 0 102 -27.5t73.5 -73.5t27.5 -102t-27.5 -102t-74.5 -73t-104 -27zM254 10 q52 0 94.5 25t67.5 66.5t25 92.5t-25 93t-67.5 67t-94.5 25q-51 0 -93.5 -22t-67.5 -62t-25 -93v-8q0 -51 25 -92.5t67.5 -66.5t93.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 476,
    d: "M448 651l-290 -651h-24l288 641l12 -9h-389v19h403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 508,
    d: "M49 196q0 47 19.5 87t53 67.5t76.5 39.5q-41 13 -67.5 47t-26.5 75q0 42 17.5 75t50.5 52.5t78 19.5t78 -20t50.5 -53.5t17.5 -74.5t-25.5 -74t-64.5 -47q43 -11 78 -39t55.5 -67.5t20.5 -87.5q0 -56 -28.5 -102.5t-75.5 -74t-103 -27.5q-57 0 -103 27.5t-73.5 74 t-27.5 102.5v0zM68 196q0 -50 24.5 -92.5t66 -68t92.5 -25.5q52 0 95 25.5t68.5 68t25.5 92.5q0 51 -25.5 92.5t-68.5 66.5t-95 25q-51 0 -92.5 -25t-66 -66.5t-24.5 -92.5v0zM123 511q0 -49 37.5 -81.5t91.5 -32.5q53 0 88.5 32.5t35.5 81.5q0 59 -35.5 94.5t-88.5 35.5 q-54 0 -91.5 -35.5t-37.5 -94.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 524,
    d: "M253 229q-56 0 -102.5 28.5t-74 76.5t-27.5 106q0 59 28 106.5t74.5 76t103.5 28.5t104 -26t74.5 -73t27.5 -113q0 -74 -30 -137.5t-79.5 -118.5t-108 -102.5t-113.5 -88.5l-14 17q88 58 149.5 113.5t98 104t51.5 86.5l15 5q-35 -46 -75.5 -67.5t-101.5 -21.5zM256 248 q84 0 135 49t51 138v13q-3 55 -28.5 96t-66.5 64t-91 23q-51 0 -93.5 -25.5t-68 -68.5t-25.5 -97t25.5 -97.5t68 -69t93.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 175,
    d: "M63 274q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16t-15.5 -6t-15.5 6t-6.5 16v0zM63 22q0 10 6.5 16.5t15.5 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 201,
    d: "M86 273q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 6.5t-7 16.5v0zM115 86q-22 -52 -43.5 -103t-42.5 -103h-19q20 52 39 103t38 103h28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 675,
    d: "M550 469l-402 -231l402 -231v-22l-439 253l439 253v-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 709,
    d: "M100 360h507v-18h-507v18zM100 166h507v-18h-507v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 646,
    d: "M114 7l401 231l-401 231v22l438 -253l-438 -253v0v22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 453,
    d: "M205 166v79q0 47 14.5 70t37.5 36.5t48 32.5q39 29 64 63t25 91q0 50 -24 90t-64 63.5t-89 23.5q-40 0 -74 -15.5t-59 -43t-36 -63.5l-18 5q10 29 27.5 53t42 42.5t54.5 29t63 10.5q55 0 99.5 -26.5t70.5 -70.5t26 -98q0 -36 -12 -66t-33.5 -55t-50.5 -46 q-26 -20 -47 -32.5t-33 -33t-12 -64.5v-75h-20zM219 33q-10 0 -17.5 7t-7.5 18q0 10 7.5 17t17.5 7q9 0 16 -7t7 -17q0 -11 -7 -18t-16 -7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 972,
    d: "M401 -208q-82 0 -146.5 23t-109 67.5t-68 107.5t-23.5 144q0 51 17.5 112.5t55 121.5t97 110.5t143.5 80.5t195 30q77 0 142.5 -25t113 -69.5t74 -104.5t26.5 -130q0 -52 -16 -100.5t-44.5 -87t-65.5 -60.5t-79 -22q-36 0 -57 17.5t-26.5 49.5t4.5 78l4 -13 q-18 -36 -48.5 -65t-68 -46t-77.5 -17q-53 0 -94.5 22.5t-64 62t-20.5 89.5q0 58 28.5 107.5t77.5 80t108 30.5q44 0 79 -15.5t59.5 -42.5t34.5 -62l20 112h15l-39 -278q-2 -21 1.5 -42t18.5 -35.5t46 -14.5q36 0 69 21t58.5 57t40.5 81.5t15 92.5q0 88 -43.5 158.5 t-120 111.5t-174.5 41q-105 0 -185 -30t-137 -79t-93 -107t-53 -115t-17 -103q0 -77 22 -138t64 -103t103 -64t141 -22q61 0 118.5 20t108.5 52l10 -16q-36 -23 -75 -39.5t-80.5 -25.5t-84.5 -9zM448 11q41 0 83 22t72 60.5t37 87.5l5 41q-2 41 -24 74t-59 53t-83 20 q-51 0 -95.5 -27t-71.5 -72.5t-27 -101.5q-1 -44 19.5 -79.5t57.5 -56.5t86 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 573,
    d: "M258 702q99 0 152 -41.5t53 -137.5q0 -40 -13.5 -77t-42 -63t-75.5 -34v7q44 -6 82 -29t62 -60t24 -86q0 -45 -18 -78.5t-48 -56.5t-68.5 -34.5t-79.5 -11.5h-167v702h139zM283 361q85 0 122.5 45.5t37.5 115.5q0 87 -50 124t-134 37h-120v-322h144zM284 18q53 0 97.5 18 t71.5 53.5t27 88.5q0 57 -30 93.5t-75 53.5t-91 17h-145v-324h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 726,
    d: "M119 0v702h161q100 0 171 -32t115.5 -84.5t65 -114t20.5 -121.5q0 -80 -27.5 -144.5t-75 -110.5t-108.5 -70.5t-128 -24.5h-194zM139 19h165q67 0 126.5 23t104.5 66.5t71 104.5t26 138q0 57 -19.5 115.5t-62 107.5t-110.5 78.5t-164 29.5h-137v-663z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 571,
    d: "M119 702h379v-19h-359v-330h320v-19h-320v-334h-20v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 735,
    d: "M617 702v-702h-20v344h-458v-344h-20v702h20v-339h458v339h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 309,
    d: "M190 93q0 -75 -25.5 -127t-69 -79t-95.5 -29v0v18q73 4 122 61.5t49 158.5v606h19v-609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 641,
    d: "M139 365l-1 -34l-3 3l384 368h26l-291 -279l334 -423h-26l-323 410l-101 -96l1 -314h-20v702h20v-337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 591,
    d: "M119 702h20v-683h402v-19h-422v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 894,
    d: "M119 0v714h1l332 -472h-9l332 472h1v-714h-20v665l2 -8l-310 -437h-2l-310 437l3 7v-664h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 813,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 530,
    d: "M265 702q58 0 103.5 -20t71.5 -61.5t26 -105.5q0 -38 -12.5 -73.5t-38.5 -63.5t-67 -44.5t-98 -16.5h-111v-317h-20v702h146zM250 336q58 0 96.5 18t60 46t31 59t9.5 58q0 40 -13.5 71t-37.5 52t-58 32t-74 11h-125v-347h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 879,
    d: "M525 19h280v-19h-312zM74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26 t109 72.5t74 108t27 132.5q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 617,
    d: "M263 702q30 0 65.5 -10t67 -32t51.5 -57.5t20 -87.5q0 -38 -12 -73.5t-37.5 -63.5t-66.5 -44.5t-101 -16.5h-111v-317h-20v702h144zM247 336q60 0 98.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-125v-347h108zM339 335l201 -335h-23 l-201 335h23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 551,
    d: "M447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18q21 -15 53 -31.5t70.5 -28t78.5 -11.5 q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 575,
    d: "M59 702h456v-19h-218v-683h-20v683h-218v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 692,
    d: "M76 702l276 -705h-10l274 705h22l-292 -734l-292 734h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 984,
    d: "M54 701h22l258 -696l-7 2l151 417l10 -23l-158 -433zM369 701h20l263 -701l-11 4l268 697h21l-285 -733z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 588,
    d: "M59 702h23l457 -702h-24zM49 0l232 364l14 -12l-223 -352h-23zM289 369l212 333h23l-222 -347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 697,
    d: "M59 0q30 41 61.5 84t64 87t65.5 88.5t66.5 89t67 88.5t66 87t63.5 84t61 81l7 -6h-441q-19 0 -31.5 3.5t-19 13t-6.5 28.5v9h21v-12q0 -10 6.5 -16.5t23.5 -6.5h472l-516 -688l-2 5h550v-19h-579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 344,
    d: "M119 747h166v-19h-144v-858h144v-19h-166v896z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 325,
    d: "M36 737q69 -189 138.5 -378t139.5 -378h-20q-70 189 -139 378t-139 378h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 344,
    d: "M226 -149h-167v19h145v858h-145v19h167v-896z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 470,
    d: "M333 480q-16 24 -33 49l-34 50l-34 50q-17 -25 -33.5 -50t-33.5 -50t-34 -49h-19q30 45 60 90.5t60 90.5v0q30 -45 60 -90.5t60 -90.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 601,
    d: "M100 19h401v-19h-401v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 205,
    d: "M-12 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 543,
    d: "M293 -6q-62 0 -112 36t-71 89l4 22v-141h-20v752h20v-502l-1 17q21 53 70.5 86t110.5 33q54 0 98 -26t70.5 -70.5t26.5 -99.5q0 -64 -27 -108t-71.5 -66t-97.5 -22zM292 11q55 0 95 23t61 63.5t21 92.5q0 48 -22 88.5t-61.5 65.5t-93.5 25q-46 0 -84 -19.5t-62.5 -53 t-31.5 -75.5v-47q0 -42 24 -79t64.5 -60.5t89.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 420,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 543,
    d: "M249 -6q-54 0 -98.5 26t-70.5 70.5t-26 99.5q0 59 26.5 103t71 68.5t98.5 24.5q60 0 110.5 -35.5t72.5 -88.5l-4 -12v502h20v-752h-20v130l3 -16q-22 -53 -71.5 -86.5t-111.5 -33.5zM251 11q49 0 89.5 23t64.5 62t24 88v33q-7 42 -32.5 76.5t-63.5 55t-82 20.5 q-50 0 -90 -22.5t-63.5 -63t-23.5 -93.5q0 -49 24 -90t64 -65t89 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 291,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 543,
    d: "M252 -182q-25 0 -51.5 6t-56 22.5t-62.5 49.5l11 13q49 -48 88 -60.5t70 -12.5q69 0 107 21.5t53.5 57t17.5 78.5l1 137l6 -6q-21 -58 -72.5 -94t-114.5 -36q-54 0 -98 26t-70.5 70.5t-26.5 99.5q0 58 27 102.5t71.5 69t98.5 24.5q60 0 109 -33.5t71 -85.5l-3 -11l6 122 h15v-386q0 -44 -17 -83.5t-60 -65t-120 -25.5zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89.5 23.5t64.5 61.5t25 82v43q-8 42 -33.5 75.5t-63 53t-82.5 19.5q-49 0 -89.5 -22.5t-64 -63t-23.5 -93.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 487,
    d: "M94 0v752h19v-480l-1 13q18 42 62.5 71t101.5 29q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -19.5t-59 -53.5t-22.5 -76v-219h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM82 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 216,
    d: "M64 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM92 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 423,
    d: "M94 0v752h20v-752h-20zM197 242l177 -242h-23l-170 231zM105 148l-1 22l231 215l13 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 208,
    d: "M94 752h20v-752h-20v752z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 765,
    d: "M109 378l3 -118l-4 10q18 53 64.5 84t102.5 31q31 0 57.5 -13.5t43.5 -36t18 -50.5l-4 -6q19 52 64 79t99 27q53 0 84.5 -30t33.5 -73v-282h-20v277q-1 35 -26 61.5t-72 29.5q-41 0 -77 -19t-59 -51.5t-25 -72.5v-225h-19v277q-2 35 -27 61.5t-72 29.5q-42 0 -78.5 -19.5 t-59 -53t-22.5 -76.5v-219h-20v378h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 487,
    d: "M109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 543,
    d: "M293 -6q-62 0 -111 33.5t-71 86.5l3 24v-319h-20v559h19l1 -141l-2 29q22 53 71.5 86.5t110.5 33.5q54 0 98 -26t70.5 -71t26.5 -100t-26.5 -99.5t-71 -70t-98.5 -25.5zM291 11q50 0 90 24t64 64.5t24 89.5q0 50 -24 91t-64 65t-89 24t-89.5 -24t-64.5 -64t-24 -89v-10 q1 -47 25.5 -86t64 -62t87.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 543,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 56 26.5 100.5t71 70.5t99.5 26q60 0 110.5 -35.5t72.5 -88.5l-5 -24v140h20v-559h-20v316l2 -22q-21 -52 -70.5 -85.5t-111.5 -33.5zM251 11q48 0 87.5 22.5t64 61t26.5 85.5v12q0 49 -24 89t-64.5 64t-89.5 24t-89 -24 t-64 -65t-24 -91q0 -49 24 -89.5t64 -64.5t89 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 321,
    d: "M109 378l3 -118l-2 11q11 36 36.5 61t59.5 38.5t71 14.5l-1 -18q-44 -1 -81 -20.5t-59 -52.5t-22 -76v-218h-20v378h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 344,
    d: "M171 -8q-28 0 -61.5 10.5t-55.5 37.5l12 12q15 -19 43 -31t62 -12q24 0 46.5 8t37.5 27.5t15 52.5q0 30 -16 47.5t-40.5 27t-51.5 18.5q-37 13 -65 33t-28 64q0 32 14.5 53t38.5 32t50 11q23 0 52 -10t51 -34l-11 -13q-17 21 -44 30t-47 9q-18 0 -37.5 -7.5t-33.5 -24.5 t-14 -44q0 -24 12 -39.5t31.5 -25t41.5 -17.5q27 -10 54 -21t44.5 -30.5t17.5 -53.5q0 -33 -13.5 -57.5t-39.5 -38.5t-65 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 304,
    d: "M133 543h20v-173h126v-17h-126v-353h-20v353h-88v17h88v173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 431,
    d: "M213 -17l-179 395h22l166 -372h-12l166 372h21l-178 -395h-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 659,
    d: "M287 378l163 -367h-6l161 367h20l-179 -401l-121 275l-112 -275l-179 401h20l165 -369l-8 4l104 258l-48 107h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 369,
    d: "M184 199l126 178h22l-136 -193zM335 0h-22l-279 378h25zM188 176l-127 -176h-23l136 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 368,
    d: "M87 360q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 278,
    d: "M181 728q-20 0 -31.5 -11t-16 -35.5t-4.5 -64.5v-148q0 -62 -9 -95t-24.5 -49t-32.5 -26q17 -10 32 -26t24.5 -49t9.5 -93v-149q0 -40 4.5 -64.5t16 -35.5t31.5 -11h56v-19h-39q-20 0 -36.5 2t-28 15t-18 45t-6.5 90v147q0 27 -6 58t-23.5 53t-49.5 23v0v28q32 2 49.5 24 t23.5 53t6 58v181q0 45 7.5 69.5t20.5 34.5t29 12t32 2h39v-19h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 223,
    d: "M99 701h19v-933h-19v933z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 324,
    d: "M143 -129q20 0 31.5 11t16 35.5t4.5 64.5v183q0 45 11 71.5t26.5 41t28.5 21.5q-18 10 -33 26t-24 49t-9 94v149q0 40 -4.5 64.5t-16 35.5t-31.5 11h-57v19h39q17 0 33 -2t28.5 -12t20 -34.5t7.5 -69.5v-147q0 -18 1 -45.5t7.5 -55t23 -47t47.5 -21.5v0v-28 q-31 -1 -47.5 -21t-23 -47.5t-7.5 -55t-1 -44.5v-147q0 -46 -7.5 -70.5t-20 -34.5t-28.5 -11.5t-33 -1.5h-39v19h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 387,
    d: "M265 457q-28 0 -45.5 14.5t-31.5 32.5q-14 15 -28 28t-35 13q-11 0 -24.5 -8t-23.5 -28.5t-12 -57.5l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q29 0 46 -15t31 -32q13 -16 28 -28.5t36 -12.5q14 0 26 8t20.5 28.5t10.5 58.5l16 -2q-1 -39 -11 -63.5t-26.5 -36t-35.5 -11.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 301
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 200,
    d: "M91 -210h18v583h-18v-583zM101 508q-10 0 -17.5 -7.5t-7.5 -17.5t7.5 -17.5t17.5 -7.5t17 7.5t7 17.5t-7 17.5t-17 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 420,
    d: "M234 441h17v-509h-17v509zM375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24 q32 0 60.5 10.5t51.5 28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 574,
    d: "M277 329v-19h-214v19h214zM128 503q0 46 20 76t56.5 45t85.5 15q67 0 102.5 -25t55.5 -65l-14 -9q-16 30 -34 47t-44 24.5t-66 7.5q-55 0 -86.5 -16t-44 -42t-12.5 -57v-353v-37q0 -17 -1.5 -35.5t-6.5 -34t-15 -24.5h-6h250q58 0 83.5 10.5t25.5 40.5v56h19v-39 q0 -17 -2 -32.5t-12.5 -28t-35 -20t-69.5 -7.5h-346v20h45q23 0 34 13t14.5 45t3.5 88v337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 500,
    d: "M349 447q32 -37 32 -86q0 -26 -9.5 -49t-25.5 -41l40 -40l-12 -12l-20 20l-20 20q-36 -32 -87 -32q-24 0 -46.5 8.5t-39.5 22.5v0l-41 -40l-12 12l40 40q-16 18 -25 41.5t-9 49.5v0q0 25 8.5 47t23.5 40q-10 9 -19 18l-19 19l12 12l38 -37q17 16 40 25.5t49 9.5t49 -9.5 t41 -26.5v0l37 37l12 -12zM131 361q0 -32 15.5 -59t42 -42.5t58.5 -15.5t58.5 15.5t42.5 42.5t16 59q0 33 -16 59.5t-42.5 42t-58.5 15.5t-58.5 -15.5t-42 -42t-15.5 -59.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 643,
    d: "M151 279h334v-19h-334v19zM151 117h333v-19h-333v19zM312 293l-263 409h24l254 -393l-9 -1l253 394h23l-262 -409v-293h-20v293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 215,
    d: "M100 701h19v-351h-19v351zM100 117h19v-350h-19v350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 560,
    d: "M349 133l-4 7q36 -11 65.5 -27t48 -42.5t18.5 -67.5q0 -42 -28 -77t-76 -55.5t-108 -20.5q-57 0 -100.5 14.5t-72.5 32t-42 25.5l10 16q20 -15 52 -31t71 -27t79 -11q48 0 92.5 16t73.5 46.5t29 73.5t-26 68t-67.5 39t-87.5 26q-36 10 -71 21.5t-63 28.5t-45 43.5 t-17 66.5q0 45 25.5 79.5t67.5 55t92 20.5l-4 -5q-38 11 -72 27.5t-55 44t-21 71.5q0 26 14 50t39.5 43t59.5 30t74 11q37 0 87 -11t87 -28l-9 -15q-28 12 -72.5 24t-90.5 13q-52 0 -90 -17.5t-58.5 -45t-20.5 -56.5q0 -42 23 -66.5t64.5 -39.5t94.5 -28q36 -9 70.5 -20.5 t62.5 -29.5t45 -45t17 -67q0 -62 -45.5 -104.5t-115.5 -55.5zM489 292q0 45 -27 72.5t-71.5 45t-96.5 31.5q-89 0 -141 -40.5t-52 -100.5q0 -48 27.5 -75t77.5 -44t118 -35q35 3 73.5 20.5t65 49t26.5 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 373,
    d: "M81 502q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM247 502q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 794,
    d: "M494 234q-18 -12 -40 -19t-47 -7q-49 0 -85 22.5t-56.5 59.5t-20.5 81q0 47 22.5 84t60 59t80.5 22q15 0 30 -2.5t29 -7.5t26 -13l-8 -15q-17 11 -36 16t-40 5q-37 0 -70 -19.5t-53.5 -52.5t-20.5 -76q0 -41 18.5 -73.5t50.5 -52t74 -19.5q21 0 40.5 6t36.5 16zM397 110 q-55 0 -102.5 19t-83 54.5t-55.5 82.5t-20 103q0 57 20 104.5t55.5 82.5t83 54.5t102.5 19.5t102.5 -19.5t83 -54.5t55.5 -82.5t20 -104.5q0 -56 -18 -103t-52.5 -82.5t-82.5 -54.5t-108 -19zM396 128q67 0 122 31.5t88 86t33 122.5q0 71 -33 126t-88 86.5t-122 31.5 q-66 0 -121 -31.5t-87.5 -86.5t-32.5 -126q0 -69 28 -123.5t82 -85.5t131 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 416,
    d: "M189 414q-40 0 -73 19t-52.5 52t-19.5 74q0 47 20 79.5t52.5 49.5t72.5 17q45 0 81 -23t52 -63l-2 -9l3 89h14v-281h-17v96l4 -10q-10 -26 -30 -46.5t-47 -32t-58 -11.5zM191 430q35 0 64.5 16t47 43.5t17.5 63.5v29q-9 45 -45 76t-84 31q-54 0 -91.5 -35t-37.5 -95 q0 -36 17.5 -65t46.5 -46.5t65 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 601,
    d: "M113 239q13 13 27.5 26.5t29.5 27.5l30 28t30 27.5t29.5 27t27.5 26.5v-22l-34.5 -34.5l-35.5 -35.5t-35.5 -36t-34.5 -35q17 -17 34.5 -35t35.5 -36t35.5 -36t34.5 -36v-21zM287 239q14 13 28 26.5t29 27.5l30 28t30 27.5t29.5 27t28.5 26.5v-22l-34.5 -34.5 l-35.5 -35.5t-35.5 -36t-34.5 -35q17 -17 34.5 -35t35.5 -36t35.5 -36t34.5 -36v-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 555,
    d: "M98 245h360v-99h-20v79h-340v20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 600,
    d: "M53 202h184v-19h-184v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 358,
    d: "M179 420q-40 0 -71.5 18t-50 49.5t-18.5 71.5t18.5 71.5t50 49.5t71.5 18q39 0 70.5 -18t50 -49.5t18.5 -71.5t-18.5 -71.5t-50 -49.5t-70.5 -18zM178 436q34 0 62 16t44.5 44t16.5 63t-16.5 63t-44.5 44t-62 16q-33 0 -61 -16t-44.5 -44t-16.5 -63t16.5 -63t44.5 -44 t61 -16zM128 645h48q18 0 35 -10.5t17 -36.5q0 -24 -13.5 -37t-42.5 -13h-27v-67h-17v164zM171 563q21 0 30.5 10t9.5 25q0 18 -12.5 24.5t-23.5 6.5h-28v-66h24zM195 553l40 -72h-18l-40 72h18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 397,
    d: "M84 508h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 282,
    d: "M59 560q0 22 10.5 40t28.5 28t40 10t39.5 -10t28 -28t10.5 -40t-10.5 -39.5t-28 -27.5t-39.5 -10t-40 10t-28.5 27.5t-10.5 39.5v0zM138 499q25 0 43 18t18 44q0 25 -18 43t-43 18q-26 0 -44 -18t-18 -43q0 -26 18 -44t44 -18v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 525,
    d: "M257 572h19v-170h170v-19h-170v-172h-19v172h-171v19h171v170zM86 152h360v-19h-360v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 397,
    d: "M105 656q12 18 34 31t49 13q44 0 70.5 -24t26.5 -74q0 -30 -15.5 -59t-39.5 -58t-52 -56.5t-54 -54.5l-5 14h181v-18h-202v5q31 29 61 58t53.5 58t38 56.5t14.5 52.5q0 45 -23.5 63.5t-55.5 18.5q-27 0 -43.5 -10.5t-27.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 412,
    d: "M168 371q-32 0 -54 12.5t-36 27.5l9 13q11 -14 31 -25.5t50 -11.5q41 0 65 28t24 68q0 38 -23.5 57t-55.5 19q-25 0 -38 -4.5t-27 -9.5l-2 3l112 145l8 -11h-144v17h161l-106 -138l-16 -2q9 7 24 11t30 4q26 2 48 -9t35 -32t13 -51q0 -32 -13.5 -57.5t-37.5 -39.5 t-57 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 211,
    d: "M161 613l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\xB5",
    horizAdvX: 487,
    d: "M211 -8q-43 0 -71.5 20.5t-39.5 55.5l14 5v-274h-20v309v270h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-3 120l3 -13q-8 -31 -33.5 -57t-60 -42t-71.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 494,
    d: "M201 423q-45 0 -82 22t-59 59t-22 83q0 45 22 82.5t59 59.5t82 22h182v-751h-19v732h-144v-732h-19v423z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 164,
    d: "M71 280q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 449,
    d: "M143 -181q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 251,
    d: "M78 651h65v-304h-20v286h-45v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 383,
    d: "M44 554q0 41 19.5 74.5t53 53.5t74.5 20t74.5 -20t53.5 -53.5t20 -74.5q0 -40 -20 -73t-53.5 -52.5t-74.5 -19.5t-74.5 19t-53 51.5t-19.5 74.5zM62 554q0 -35 17.5 -64.5t46.5 -47t65 -17.5q35 0 64.5 17.5t47 47t17.5 64.5q0 36 -17.5 66t-47 47.5t-64.5 17.5 q-37 0 -66 -18.5t-46 -48.5t-17 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 601,
    d: "M465 239q-14 13 -28.5 26.5t-29.5 27.5l-30 28t-30 27.5t-29.5 27t-27.5 26.5v-22l34.5 -34.5l35.5 -35.5t35.5 -36t34.5 -35q-17 -17 -34.5 -35t-35.5 -36t-35.5 -36t-34.5 -36v-21zM290 239q-14 13 -28 26.5t-29 27.5l-30 28t-30 27.5t-29.5 27t-28.5 26.5v-22 l34.5 -34.5l35.5 -35.5t35.5 -36t34.5 -35q-17 -17 -34.5 -35t-35.5 -36t-35.5 -36t-34.5 -36v-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 725,
    d: "M541 664l-406 -664h-21l406 664h21zM79 651h65v-304h-20v286h-45v18zM667 124v-16h-219v10l174 196h8v-314h-19v290l5 -8l-147 -164l-5 6h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 786,
    d: "M79 652h65v-304h-20v286h-45v18zM493 285q12 18 34 31t49 13q44 0 70.5 -24t26.5 -74q0 -30 -15.5 -59t-39.5 -58t-52 -56.5t-54 -54.5l-5 14h181v-18h-202v5q31 29 61 58t53.5 58t38 56.5t14.5 52.5q0 45 -23.5 63.5t-55.5 18.5q-27 0 -43.5 -10.5t-27.5 -26.5zM554 665 l-406 -665h-21l406 665h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 695,
    d: "M140 371q-32 0 -54 12.5t-36 27.5l9 13q11 -14 31 -25.5t50 -11.5q41 0 65 28t24 68q0 38 -23.5 57t-55.5 19q-25 0 -38 -4.5t-27 -9.5l-2 3l112 145l8 -11h-144v17h161l-106 -138l-16 -2q9 7 24 11t30 4q26 2 48 -9t35 -32t13 -51q0 -32 -13.5 -57.5t-37.5 -39.5 t-57 -14zM548 665l-406 -665h-21l406 665h21zM635 124v-15h-218l-1 9l174 196h8v-314h-19v290l5 -8l-147 -164l-5 6h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 412,
    d: "M245 374v-80q0 -47 -14.5 -70t-37.5 -36.5t-48 -32.5q-39 -29 -64 -63t-25 -90q0 -51 24 -91t64 -63t89 -23q39 0 73.5 15t59.5 42.5t36 63.5l18 -5q-10 -29 -27.5 -53t-42.5 -42.5t-54.5 -29t-62.5 -10.5q-55 0 -99.5 26.5t-70.5 70.5t-26 98q0 36 12 66t33.5 55 t50.5 46q26 20 47 32.5t33 33t12 64.5v76h20zM231 506q10 0 17.5 -7t7.5 -18q0 -10 -7.5 -17t-17.5 -7q-9 0 -16 7t-7 17q0 11 7 18t16 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM260 884h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM459 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM469 768l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM426 770q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5 t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM249 786q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM415 786q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5 q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM290 836q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM306 836q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5 q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 923,
    d: "M463 702h367v-20h-347v-319h308v-19h-308v-324h361v-20h-381v702zM476 694q-2 -6 -4.5 -13t-4.5 -13l-421 -668h-22l439 702zM166 224h306v-18h-308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5zM337 -181q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60 q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM221 884h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM420 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM431 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM211 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM377 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5 v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM34 884h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM233 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM243 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM23 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM189 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 726,
    d: "M119 0v702h161q100 0 171 -32t115.5 -84.5t65 -114t20.5 -121.5q0 -80 -27.5 -144.5t-75 -110.5t-108.5 -70.5t-128 -24.5h-194zM139 19h165q67 0 126.5 23t104.5 66.5t71 104.5t26 138q0 57 -19.5 115.5t-62 107.5t-110.5 78.5t-164 29.5h-137v-663zM11 360h232v-19 h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 813,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM477 768q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75 l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM338 883h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM537 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM547 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM504 769q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32 q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM327 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM493 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5 t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 501,
    d: "M263 150q30 30 60.5 60t60.5 60l7 -7l7 -7q-30 -31 -60 -60.5t-60 -59.5q30 -31 60 -61l61 -61l-15 -14l-60.5 60.5l-60.5 60.5q-30 -30 -60 -60.5t-60 -60.5q-4 3 -7.5 7t-6.5 7q30 31 59.5 61t60.5 60l-120 120l15 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 856,
    d: "M724 707l-592 -708l-12 11l593 708zM74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26 q71 0 133 26t109 72.5t74 108t27 132.5q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM251 884h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM450 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM461 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM241 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5 t-15.5 6.5t-6.5 15.5v0zM407 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM427 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 530,
    d: "M264 539q30 0 65.5 -10t66.5 -32t50.5 -57.5t19.5 -87.5q0 -38 -12.5 -73.5t-38.5 -63.5t-67 -44.5t-97 -16.5h-112v-154h-20v701h20v-162h125zM253 174q57 0 94.5 17.5t59 45.5t30.5 59t9 58q0 49 -25 86.5t-68.5 58t-98.5 20.5h-115v-345h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 562,
    d: "M115 428q0 73 20.5 124t59.5 78t95 29q53 -1 87 -21.5t51 -52t17 -65.5q0 -49 -25 -82t-66 -49q44 -10 78.5 -38t54.5 -68t20 -88q0 -57 -27.5 -103t-74 -73t-102.5 -27q-30 0 -57 8t-50 22l9 15q20 -14 44.5 -21t50.5 -7q52 0 94.5 25.5t68 68t25.5 93.5q0 50 -24 91.5 t-65 66.5t-93 25h-4v19q51 0 87 31.5t36 84.5q0 32 -14.5 61t-44 47t-74.5 18q-78 0 -118 -57.5t-40 -152.5v-430h-19v368h-65v19h65v41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM176 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM347 595l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM387 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM343 449q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5 t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM167 503q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM333 503q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5 t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM207 503q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM223 503q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5 q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 759,
    d: "M202 -11q-52 0 -84.5 16.5t-48 41.5t-15.5 52q0 39 19.5 65t50 39t64.5 13q53 0 100.5 -25.5t74.5 -69.5l-6 -12q-34 42 -76.5 65.5t-90.5 23.5q-25 0 -51.5 -10t-44.5 -31t-18 -55q0 -39 30 -66.5t98 -27.5q19 0 46 4t53.5 14.5t42.5 29.5v127l18 -24l1 -109 q-21 -27 -54 -40t-63.5 -17t-45.5 -4zM347 184v79q0 43 -14.5 65t-38.5 30t-53 8q-39 0 -75.5 -14t-74.5 -53l-12 16q30 31 70.5 50.5t92.5 19.5q47 0 74 -14t39 -40.5t12 -61.5v-25zM543 -6q-55 0 -99.5 26t-70.5 70.5t-26 99.5q0 54 26 99t70.5 71.5t99.5 26.5 q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l333 134l-6 -10q-21 44 -59.5 76t-90.5 32q-50 0 -90 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t62 -66.5t93 -25.5q35 0 66.5 13t55.5 35l13 -14q-27 -23 -61.5 -37t-73.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 420,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z M146 -180q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM138 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM309 595l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM349 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM129 503q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM295 503q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM7 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM178 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM218 479l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM-2 502q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM164 502q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 503,
    d: "M250 -6q-54 0 -98.5 25.5t-71 69.5t-26.5 101q0 54 26.5 99t70.5 71.5t98 26.5q32 0 60 -9.5t51 -26.5t40 -38t28 -43l-3 -18q-7 58 -35 123.5t-69.5 130.5t-90 120t-97.5 90l10 13q56 -41 110.5 -102.5t98.5 -134.5t70.5 -150t26.5 -147q0 -42 -16 -78t-43.5 -64 t-63.5 -43.5t-76 -15.5zM251 11q49 0 89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26t-63 -67t-23 -86q0 -50 23.5 -90.5t64 -64.5t89.5 -24zM318 686l-169 -111l-10 12l169 110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 487,
    d: "M109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15zM314 449q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28 t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM155 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM326 595l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM366 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM323 449q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM146 503q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM312 503q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 501,
    d: "M229 345q0 9 6.5 15.5t15.5 6.5t16 -6.5t7 -15.5t-7 -15.5t-16 -6.5t-15.5 6.5t-6.5 15.5v0zM229 92q0 9 6.5 15.5t15.5 6.5t16 -6.5t7 -15.5t-7 -15.5t-16 -6.5t-15.5 6.5t-6.5 15.5v0zM68 229h360v-19h-360v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 481,
    d: "M403 369l-311 -371l-11 13l311 369zM54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5 t-64 65t-89 24.5q-51 0 -91 -26t-63 -67t-23 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM147 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM318 595l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM358 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM138 503q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5 t-6.5 15.5v0zM304 503q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM290 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 520,
    d: "M283 -6q-41 0 -79 16.5t-65 45.5t-37 65l2 21v-323h-19v933h19v-508l-5 9q11 39 39.5 69t67 47t78.5 17q55 0 99 -26t70 -71t26 -100q0 -56 -26 -100t-70.5 -69.5t-99.5 -25.5zM282 12q49 0 89.5 24t64.5 64t24 89q0 53 -24.5 93t-65 63t-88.5 23q-49 0 -89 -24 t-64 -63.5t-25 -88.5v-16q3 -46 27.5 -83t64 -59t86.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM110 502q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM276 502q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5 t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM239 775h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM158 509h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM357 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM268 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM607 -188q-28 0 -50 21t-22 56q0 38 29.5 70.5t68.5 52.5l14 -12q-45 -25 -69 -53t-24 -57q0 -28 17 -44t38 -16q19 0 35 13t26 32l13 -9q-10 -22 -30 -38t-46 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 543,
    d: "M249 -6q-54 0 -98 26t-70 70t-26 99q0 63 26.5 107t70.5 67t97 23q41 0 76.5 -15.5t62.5 -42.5t41 -62l4 112h16v-377q-43 -25 -67 -53.5t-24 -57.5q0 -28 16.5 -44t37.5 -16q20 0 35.5 13t26.5 32l13 -9q-11 -22 -31 -38t-45 -16q-29 0 -51 21t-22 56q0 37 28.5 69 t65.5 52l3 -9l-6 -1v126l1 -11q-14 -35 -41 -62t-62.5 -43t-77.5 -16zM251 11q49 0 89 22t64.5 60.5t24.5 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20q-49 0 -89 -22t-64 -62.5t-24 -94.5q0 -50 24 -90.5t64 -64.5t89 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5zM518 883l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 420,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z M324 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5zM528 777l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 420,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z M364 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5zM391 794q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 420,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z M227 498q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5zM300 903l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 420,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z M137 580l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 726,
    d: "M119 0v702h161q100 0 171 -32t115.5 -84.5t65 -114t20.5 -121.5q0 -80 -27.5 -144.5t-75 -110.5t-108.5 -70.5t-128 -24.5h-194zM139 19h165q67 0 126.5 23t104.5 66.5t71 104.5t26 138q0 57 -19.5 115.5t-62 107.5t-110.5 78.5t-164 29.5h-137v-663zM177 892l119 -137 l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 619,
    d: "M249 -6q-54 0 -98.5 26t-70.5 70.5t-26 99.5q0 59 26.5 103t71 68.5t98.5 24.5q60 0 110.5 -35.5t72.5 -88.5l-4 -12v502h20v-752h-20v130l3 -16q-22 -53 -71.5 -86.5t-111.5 -33.5zM251 11q49 0 89.5 23t64.5 62t24 88v33q-7 42 -32.5 76.5t-63.5 55t-82 20.5 q-50 0 -90 -22.5t-63.5 -63t-23.5 -93.5q0 -49 24 -90t64 -65t89 -24zM551 575l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 726,
    d: "M119 0v702h161q100 0 171 -32t115.5 -84.5t65 -114t20.5 -121.5q0 -80 -27.5 -144.5t-75 -110.5t-108.5 -70.5t-128 -24.5h-194zM139 19h165q67 0 126.5 23t104.5 66.5t71 104.5t26 138q0 57 -19.5 115.5t-62 107.5t-110.5 78.5t-164 29.5h-137v-663zM11 360h232v-19 h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 543,
    d: "M249 -6q-54 0 -98.5 26t-70.5 70.5t-26 99.5q0 59 26.5 103t71 68.5t98.5 24.5q60 0 110.5 -35.5t72.5 -88.5l-4 -12v502h20v-752h-20v130l3 -16q-22 -53 -71.5 -86.5t-111.5 -33.5zM251 11q49 0 89.5 23t64.5 62t24 88v33q-7 42 -32.5 76.5t-63.5 55t-82 20.5 q-50 0 -90 -22.5t-63.5 -63t-23.5 -93.5q0 -49 24 -90t64 -65t89 -24zM321 635h232v-19h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM201 775h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM120 509h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM318 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM230 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM294 784q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM212 498q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM511 -188q-28 0 -50 21t-22 56q0 38 29.5 70.5t68.5 52.5l14 -12q-45 -25 -69 -53t-24 -57q0 -28 17 -44t38 -16q19 0 35 13t26 32l13 -9q-10 -22 -30 -38t-46 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 467,
    d: "M339 -188q-32 0 -57 24t-25 63q0 29 14 57.5t41 52.5l11 -1q-8 -4 -20 -7.5t-25.5 -5t-26.5 -1.5q-55 0 -99.5 26t-70.5 70.5t-26 99.5q0 54 26 99t70.5 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-5 17l332 133l-6 -9q-24 48 -62 78t-88 30t-90 -24 t-63.5 -65t-23.5 -90q0 -47 23 -88t63 -66t91 -25q35 0 66.5 13t55.5 35l13 -14q-18 -15 -37 -28.5t-35.5 -29t-26.5 -36.5t-10 -51q0 -32 19.5 -51t44.5 -19q14 0 27 7.5t23 20.5l11 -13q-12 -14 -28 -23.5t-35 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM203 893l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM122 580l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261zM515 766l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 543,
    d: "M252 -182q-25 0 -51.5 6t-56 22.5t-62.5 49.5l11 13q49 -48 88 -60.5t70 -12.5q69 0 107 21.5t53.5 57t17.5 78.5l1 137l6 -6q-21 -58 -72.5 -94t-114.5 -36q-54 0 -98 26t-70.5 70.5t-26.5 99.5q0 58 27 102.5t71.5 69t98.5 24.5q60 0 109 -33.5t71 -85.5l-3 -11l6 122 h15v-386q0 -44 -17 -83.5t-60 -65t-120 -25.5zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89.5 23.5t64.5 61.5t25 82v43q-8 42 -33.5 75.5t-63 53t-82.5 19.5q-49 0 -89.5 -22.5t-64 -63t-23.5 -93.5zM387 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261zM403 755q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 543,
    d: "M252 -182q-25 0 -51.5 6t-56 22.5t-62.5 49.5l11 13q49 -48 88 -60.5t70 -12.5q69 0 107 21.5t53.5 57t17.5 78.5l1 137l6 -6q-21 -58 -72.5 -94t-114.5 -36q-54 0 -98 26t-70.5 70.5t-26.5 99.5q0 58 27 102.5t71.5 69t98.5 24.5q60 0 109 -33.5t71 -85.5l-3 -11l6 122 h15v-386q0 -44 -17 -83.5t-60 -65t-120 -25.5zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89.5 23.5t64.5 61.5t25 82v43q-8 42 -33.5 75.5t-63 53t-82.5 19.5q-49 0 -89.5 -22.5t-64 -63t-23.5 -93.5zM267 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70 t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261zM378 784q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 543,
    d: "M252 -182q-25 0 -51.5 6t-56 22.5t-62.5 49.5l11 13q49 -48 88 -60.5t70 -12.5q69 0 107 21.5t53.5 57t17.5 78.5l1 137l6 -6q-21 -58 -72.5 -94t-114.5 -36q-54 0 -98 26t-70.5 70.5t-26.5 99.5q0 58 27 102.5t71.5 69t98.5 24.5q60 0 109 -33.5t71 -85.5l-3 -11l6 122 h15v-386q0 -44 -17 -83.5t-60 -65t-120 -25.5zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89.5 23.5t64.5 61.5t25 82v43q-8 42 -33.5 75.5t-63 53t-82.5 19.5q-49 0 -89.5 -22.5t-64 -63t-23.5 -93.5zM250 498q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5 t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261zM344 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    horizAdvX: 519,
    d: "M237 507q22 52 43 103t43 103h18q-19 -52 -38 -103t-39 -103h-27zM252 -182q-25 0 -51.5 6t-56 22.5t-62.5 49.5l11 13q49 -48 88 -60.5t70 -12.5q69 0 107 21.5t53.5 57t17.5 78.5l1 137l6 -6q-21 -58 -72.5 -94t-114.5 -36q-54 0 -98 26t-70.5 70.5t-26.5 99.5 q0 58 27 102.5t71.5 69t98.5 24.5q60 0 109 -33.5t71 -85.5l-3 -11l6 122h15v-386q0 -44 -17 -83.5t-60 -65t-120 -25.5zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89.5 23.5t64.5 61.5t25 82v43q-8 42 -33.5 75.5t-63 53t-82.5 19.5q-49 0 -89.5 -22.5t-64 -63 t-23.5 -93.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 735,
    d: "M617 702v-702h-20v344h-458v-344h-20v702h20v-339h458v339h20zM482 766l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 487,
    d: "M94 0v752h19v-480l-1 13q18 42 62.5 71t101.5 29q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -19.5t-59 -53.5t-22.5 -76v-219h-20zM211 802l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 894,
    d: "M119 510h656v-18h-656v18zM667 702v-702h-20v344h-458v-344h-20v702h20v-339h458v339h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 487,
    d: "M94 0v752h19v-480l-1 13q18 42 62.5 71t101.5 29q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -19.5t-59 -53.5t-22.5 -76v-219h-20zM-13 573h232v-19h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM200 769q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM175 448q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5 t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM14 775h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM-11 508h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM131 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM99 461q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 255,
    d: "M98 -188q-29 0 -51 21t-22 56q0 38 29.5 70t69.5 53l9 -6l4 -6q-45 -25 -68.5 -53t-23.5 -57q0 -28 16.5 -44t37.5 -16q20 0 35.5 13t26.5 32l12 -9q-10 -22 -30 -38t-45 -16zM119 702h20v-702h-20v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 208,
    d: "M75 -188q-28 0 -50 21t-22 56q0 38 29.5 70.5t68.5 52.5l8 -6l5 -6q-45 -25 -68.5 -53t-23.5 -57q0 -28 17 -44t38 -16q19 0 34.5 13t26.5 32l13 -9q-11 -22 -31 -38t-45 -16zM94 378h20v-378h-20v378zM81 466q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5 t-15.5 -6.5t-16 7t-7 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM106 784q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 567,
    d: "M119 702h20v-702h-20v702zM448 93q0 -75 -25.5 -127t-69 -79t-95.5 -29v0v18q73 4 122 61.5t49 158.5v606h19v-609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 424,
    d: "M94 378h20v-378h-20v378zM82 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM272 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM300 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5 t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 309,
    d: "M190 93q0 -75 -25.5 -127t-69 -79t-95.5 -29v0v18q73 4 122 61.5t49 158.5v606h19v-609zM285 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 216,
    d: "M64 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM228 479l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 641,
    d: "M139 365l-1 -34l-3 3l384 368h26l-291 -279l334 -423h-26l-323 410l-101 -96l1 -314h-20v702h20v-337zM260 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 423,
    d: "M94 0v752h20v-752h-20zM197 242l177 -242h-23l-170 231zM105 148l-1 22l231 215l13 -11zM166 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 420,
    d: "M108 141l-3 19l226 218h26zM114 0h-20v378h20v-378zM164 211l201 -211h-26l-188 198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 591,
    d: "M119 702h20v-683h402v-19h-422v702zM233 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 208,
    d: "M94 752h20v-752h-20v752zM214 924l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 591,
    d: "M119 702h20v-683h402v-19h-422v702zM265 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 208,
    d: "M94 752h20v-752h-20v752zM58 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 573,
    d: "M119 702h20v-683h402v-19h-422v702zM270 572l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 350,
    d: "M94 752h20v-752h-20v752zM248 575l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 621,
    d: "M119 702h20v-683h402v-19h-422v702zM537 371q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 259,
    d: "M94 752h20v-752h-20v752zM217 282q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 573,
    d: "M350 412l1 -18l-318 -116l-1 18zM119 702h20v-683h402v-19h-422v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 190,
    d: "M184 352v-19l-156 -56v18zM95 752h19v-752h-19v752z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 813,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM510 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 487,
    d: "M109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15zM318 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 813,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM362 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 487,
    d: "M109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15zM198 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 813,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM292 892l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 487,
    d: "M109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15zM131 580l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 502,
    d: "M-5 387l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5zM124 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 811,
    d: "M692 -13l-560 679l5 10v-676h-19v713h1l565 -687l-10 2l-1 674h20v-713zM693 61v-68q0 -57 -16 -101t-44 -73l-15 12q25 28 40 68t15 91v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 487,
    d: "M393 -6q0 -58 -16 -102t-44 -73l-15 12q25 28 40 68t15 91v281q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15l4 -108q15 54 60.5 84.5t102.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM317 774h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM137 509h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM435 755q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM247 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM499 896l-92 -133h-19l89 133h22zM595 896l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM309 614l-92 -133h-19l89 133h22zM405 614l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1009,
    d: "M511 683q-18 4 -36.5 6t-37.5 2q-70 0 -131 -27t-107.5 -74t-73 -109t-26.5 -132t26 -131.5t72.5 -108t108 -72.5t132.5 -26q35 0 72 9l16 -17q-21 -5 -43.5 -8t-45.5 -3q-74 0 -139 28t-114 77t-77 114t-28 139t28 139.5t77 115t114 77.5t139 28q24 0 46.5 -3t44.5 -9z M505 702h389v-20h-369v-319h330v-19h-330v-324h383v-20h-403v702z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 710,
    d: "M375 37q-26 -20 -57.5 -31.5t-66.5 -11.5q-55 0 -99.5 26t-71 70t-26.5 99t26.5 99.5t71 71t98.5 26.5q36 0 68 -11.5t57 -32.5l-11 -14q-23 18 -52 29.5t-61 11.5q-50 0 -90 -24.5t-63.5 -65t-23.5 -90.5q0 -49 23.5 -89.5t64 -64.5t89.5 -24q32 0 60.5 10.5t51.5 28.5z M494 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35l13 -14 q-27 -23 -61.5 -37t-73.5 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 617,
    d: "M263 702q30 0 65.5 -10t67 -32t51.5 -57.5t20 -87.5q0 -38 -12 -73.5t-37.5 -63.5t-66.5 -44.5t-101 -16.5h-111v-317h-20v702h144zM247 336q60 0 98.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-125v-347h108zM339 335l201 -335h-23 l-201 335h23zM367 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 321,
    d: "M109 378l3 -118l-2 11q11 36 36.5 61t59.5 38.5t71 14.5l-1 -18q-44 -1 -81 -20.5t-59 -52.5t-22 -76v-218h-20v378h15zM235 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 617,
    d: "M263 702q30 0 65.5 -10t67 -32t51.5 -57.5t20 -87.5q0 -38 -12 -73.5t-37.5 -63.5t-66.5 -44.5t-101 -16.5h-111v-317h-20v702h144zM247 336q60 0 98.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-125v-347h108zM339 335l201 -335h-23 l-201 335h23zM220 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 321,
    d: "M109 378l3 -118l-2 11q11 36 36.5 61t59.5 38.5t71 14.5l-1 -18q-44 -1 -81 -20.5t-59 -52.5t-22 -76v-218h-20v378h15zM112 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 617,
    d: "M263 702q30 0 65.5 -10t67 -32t51.5 -57.5t20 -87.5q0 -38 -12 -73.5t-37.5 -63.5t-66.5 -44.5t-101 -16.5h-111v-317h-20v702h144zM247 336q60 0 98.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-125v-347h108zM339 335l201 -335h-23 l-201 335h23zM150 893l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 321,
    d: "M109 378l3 -118l-2 11q11 36 36.5 61t59.5 38.5t71 14.5l-1 -18q-44 -1 -81 -20.5t-59 -52.5t-22 -76v-218h-20v378h15zM48 579l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 551,
    d: "M447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18q21 -15 53 -31.5t70.5 -28t78.5 -11.5 q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28zM381 892l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 344,
    d: "M171 -8q-28 0 -61.5 10.5t-55.5 37.5l12 12q15 -19 43 -31t62 -12q24 0 46.5 8t37.5 27.5t15 52.5q0 30 -16 47.5t-40.5 27t-51.5 18.5q-37 13 -65 33t-28 64q0 32 14.5 53t38.5 32t50 11q23 0 52 -10t51 -34l-11 -13q-17 21 -44 30t-47 9q-18 0 -37.5 -7.5t-33.5 -24.5 t-14 -44q0 -24 12 -39.5t31.5 -25t41.5 -17.5q27 -10 54 -21t44.5 -30.5t17.5 -53.5q0 -33 -13.5 -57.5t-39.5 -38.5t-65 -14zM247 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 551,
    d: "M447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18q21 -15 53 -31.5t70.5 -28t78.5 -11.5 q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28zM391 785l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 344,
    d: "M171 -8q-28 0 -61.5 10.5t-55.5 37.5l12 12q15 -19 43 -31t62 -12q24 0 46.5 8t37.5 27.5t15 52.5q0 30 -16 47.5t-40.5 27t-51.5 18.5q-37 13 -65 33t-28 64q0 32 14.5 53t38.5 32t50 11q23 0 52 -10t51 -34l-11 -13q-17 21 -44 30t-47 9q-18 0 -37.5 -7.5t-33.5 -24.5 t-14 -44q0 -24 12 -39.5t31.5 -25t41.5 -17.5q27 -10 54 -21t44.5 -30.5t17.5 -53.5q0 -33 -13.5 -57.5t-39.5 -38.5t-65 -14zM287 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 551,
    d: "M447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18q21 -15 53 -31.5t70.5 -28t78.5 -11.5 q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28zM199 -182q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5 t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 344,
    d: "M171 -8q-28 0 -61.5 10.5t-55.5 37.5l12 12q15 -19 43 -31t62 -12q24 0 46.5 8t37.5 27.5t15 52.5q0 30 -16 47.5t-40.5 27t-51.5 18.5q-37 13 -65 33t-28 64q0 32 14.5 53t38.5 32t50 11q23 0 52 -10t51 -34l-11 -13q-17 21 -44 30t-47 9q-18 0 -37.5 -7.5t-33.5 -24.5 t-14 -44q0 -24 12 -39.5t31.5 -25t41.5 -17.5q27 -10 54 -21t44.5 -30.5t17.5 -53.5q0 -33 -13.5 -57.5t-39.5 -38.5t-65 -14zM107 -181q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4 q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 551,
    d: "M447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18q21 -15 53 -31.5t70.5 -28t78.5 -11.5 q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28zM163 911l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 344,
    d: "M171 -8q-28 0 -61.5 10.5t-55.5 37.5l12 12q15 -19 43 -31t62 -12q24 0 46.5 8t37.5 27.5t15 52.5q0 30 -16 47.5t-40.5 27t-51.5 18.5q-37 13 -65 33t-28 64q0 32 14.5 53t38.5 32t50 11q23 0 52 -10t51 -34l-11 -13q-17 21 -44 30t-47 9q-18 0 -37.5 -7.5t-33.5 -24.5 t-14 -44q0 -24 12 -39.5t31.5 -25t41.5 -17.5q27 -10 54 -21t44.5 -30.5t17.5 -53.5q0 -33 -13.5 -57.5t-39.5 -38.5t-65 -14zM60 580l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 575,
    d: "M59 702h456v-19h-218v-683h-20v683h-218v19zM210 -181q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5 t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 304,
    d: "M133 543h20v-173h126v-17h-126v-353h-20v353h-88v17h88v173zM64 -180q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43 t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 575,
    d: "M59 702h456v-19h-218v-683h-20v683h-218v19zM174 892l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 304,
    d: "M133 543h20v-173h126v-17h-126v-353h-20v353h-88v17h88v173zM213 458l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 575,
    d: "M59 702h456v-19h-218v-683h-20v683h-218v19zM171 360h232v-19h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 304,
    d: "M133 543h20v-173h126v-17h-126v-353h-20v353h-88v17h88v173zM38 214h232v-19h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM418 769q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5 t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM314 449q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28 t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM231 775h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM129 509h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM349 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5 t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM239 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5 t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM282 835q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18 t-46.5 18t-18.5 46zM298 835q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM178 503q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18 t-18.5 46zM194 503q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM413 897l-92 -133h-19l89 133h22zM509 897l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM301 614l-92 -133h-19l89 133h22zM397 614l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 693,
    d: "M439 -188q-28 0 -50 21t-22 56q0 33 18 66.5t47 56.5l7 3l-2 -6q-38 -17 -91 -17q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -48 -12.5 -86t-34 -66t-50.5 -47q-44 -32 -68 -66.5 t-24 -72.5q0 -28 17 -44t38 -16q19 0 34.5 13t26.5 32l13 -9q-10 -22 -30.5 -38t-45.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 487,
    d: "M361 -188q-28 0 -50 21t-22 56q0 36 26 68.5t63 52.5l7 -5l8 -5q-41 -25 -63 -53.5t-22 -56.5t17 -44t38 -16q19 0 34.5 13t26.5 32l13 -9q-11 -22 -31 -38t-45 -16zM211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5 t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 984,
    d: "M54 701h22l258 -696l-7 2l151 417l10 -23l-158 -433zM369 701h20l263 -701l-11 4l268 697h21l-285 -733zM606 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 659,
    d: "M287 378l163 -367h-6l161 367h20l-179 -401l-121 275l-112 -275l-179 401h20l165 -369l-8 4l104 258l-48 107h20zM444 479l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM437 766l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM330 479l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM217 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM383 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5 t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 697,
    d: "M59 0q30 41 61.5 84t64 87t65.5 88.5t66.5 89t67 88.5t66 87t63.5 84t61 81l7 -6h-441q-19 0 -31.5 3.5t-19 13t-6.5 28.5v9h21v-12q0 -10 6.5 -16.5t23.5 -6.5h472l-516 -688l-2 5h550v-19h-579zM452 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 368,
    d: "M87 360q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220zM267 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 697,
    d: "M59 0q30 41 61.5 84t64 87t65.5 88.5t66.5 89t67 88.5t66 87t63.5 84t61 81l7 -6h-441q-19 0 -31.5 3.5t-19 13t-6.5 28.5v9h21v-12q0 -10 6.5 -16.5t23.5 -6.5h472l-516 -688l-2 5h550v-19h-579zM326 784q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5 t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 368,
    d: "M87 360q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220zM170 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 697,
    d: "M59 0q30 41 61.5 84t64 87t65.5 88.5t66.5 89t67 88.5t66 87t63.5 84t61 81l7 -6h-441q-19 0 -31.5 3.5t-19 13t-6.5 28.5v9h21v-12q0 -10 6.5 -16.5t23.5 -6.5h472l-516 -688l-2 5h550v-19h-579zM235 892l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 368,
    d: "M87 360q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220zM80 579l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 812,
    d: "M374 711q77 0 143 -28t115.5 -78t77.5 -115.5t28 -140.5t-28 -139.5t-78 -113.5t-116 -76.5t-142 -27.5q-77 0 -138.5 29.5t-106 80.5t-70.5 116l640 259l7 -17l-629 -256l7 12q39 -93 116 -149t175 -56q71 0 133.5 26.5t109.5 73t73.5 107.5t26.5 130q0 66 -24.5 127.5 t-70 110t-109 77t-140.5 28.5q-44 0 -87 -13t-81 -34.5t-68 -48.5l-12 14q32 31 72 53.5t84.5 35.5t91.5 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 284,
    d: "M95 518q0 75 26 126t69 78.5t95 29.5v-20q-46 0 -85 -26t-62 -73t-23 -111v-147h130v-19h-130v-295q0 -75 -25.5 -126t-68.5 -78.5t-95 -29.5v20q45 0 84 26t62 73t23 112v298h-65v19h65v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni019D",
    unicode: "\u019D",
    horizAdvX: 812,
    d: "M692 -13l-560 679l5 10v-676h-19v713h1l565 -686l-10 1l-1 674h20v-713zM137 61v-68q0 -57 -15.5 -101t-43.5 -73l-15 12q24 28 39.5 68t15.5 91v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM505 702q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM311 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM562 698q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 491,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM379 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1423,
    d: "M119 0v702h161q100 0 171 -32t115.5 -84.5t65 -114t20.5 -121.5q0 -80 -27.5 -144.5t-75 -110.5t-108.5 -70.5t-128 -24.5h-194zM139 19h165q67 0 126.5 23t104.5 66.5t71 104.5t26 138q0 57 -19.5 115.5t-62 107.5t-110.5 78.5t-164 29.5h-137v-663zM785 0 q30 41 61.5 84t64 87t65.5 88.5t66.5 89t67 88.5t66 87t63.5 84t61 81l7 -6h-441q-19 0 -31.5 3.5t-19 13t-6.5 28.5v9h21v-12q0 -10 6.5 -16.5t23.5 -6.5h472l-516 -688l-2 5h550v-19h-579zM961 892l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1094,
    d: "M119 0v702h161q100 0 171 -32t115.5 -84.5t65 -114t20.5 -121.5q0 -80 -27.5 -144.5t-75 -110.5t-108.5 -70.5t-128 -24.5h-194zM139 19h165q67 0 126.5 23t104.5 66.5t71 104.5t26 138q0 57 -19.5 115.5t-62 107.5t-110.5 78.5t-164 29.5h-137v-663zM813 360 q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220zM806 579l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 911,
    d: "M249 -6q-54 0 -98.5 26t-70.5 70.5t-26 99.5q0 59 26.5 103t71 68.5t98.5 24.5q60 0 110.5 -35.5t72.5 -88.5l-4 -12v502h20v-752h-20v130l3 -16q-22 -53 -71.5 -86.5t-111.5 -33.5zM251 11q49 0 89.5 23t64.5 62t24 88v33q-7 42 -32.5 76.5t-63.5 55t-82 20.5 q-50 0 -90 -22.5t-63.5 -63t-23.5 -93.5q0 -49 24 -90t64 -65t89 -24zM630 360q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220zM623 579l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 901,
    d: "M119 702h20v-683h402v-19h-422v702zM781 93q0 -75 -25.5 -127t-69 -79t-95.5 -29v0v18q73 4 122 61.5t49 158.5v606h19v-609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 807,
    d: "M119 702h20v-683h402v-19h-422v702zM655 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM683 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 424,
    d: "M94 752h20v-752h-20v752zM272 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM300 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1122,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM1003 93q0 -75 -25.5 -127t-69 -79t-95.5 -29v0v18q73 4 122 61.5t49 158.5v606h19v-609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1029,
    d: "M693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM877 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM905 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 703,
    d: "M109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15zM551 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5z M579 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01D3",
    unicode: "\u01D3",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM233 893l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcaron",
    unicode: "\u01E6",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261zM287 892l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcaron",
    unicode: "\u01E7",
    horizAdvX: 543,
    d: "M252 -182q-25 0 -51.5 6t-56 22.5t-62.5 49.5l11 13q49 -48 88 -60.5t70 -12.5q69 0 107 21.5t53.5 57t17.5 78.5l1 137l6 -6q-21 -58 -72.5 -94t-114.5 -36q-54 0 -98 26t-70.5 70.5t-26.5 99.5q0 58 27 102.5t71.5 69t98.5 24.5q60 0 109 -33.5t71 -85.5l-3 -11l6 122 h15v-386q0 -44 -17 -83.5t-60 -65t-120 -25.5zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89.5 23.5t64.5 61.5t25 82v43q-8 42 -33.5 75.5t-63 53t-82.5 19.5q-49 0 -89.5 -22.5t-64 -63t-23.5 -93.5zM160 580l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EA",
    unicode: "\u01EA",
    horizAdvX: 865,
    d: "M432 -8q-74 0 -139 26.5t-114 74.5t-77 113.5t-28 143.5q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5q0 -70 -21 -124t-53.5 -94t-69.5 -67q-35 -26 -69.5 -44.5t-63 -35.5t-45.5 -39.5t-17 -55.5q0 -28 16.5 -44t37.5 -16 q20 0 35.5 13t26.5 32l12 -9q-10 -22 -30 -38t-45 -16q-29 0 -51 21t-22 56t18 60t45 42t54 29l2 -6q-21 -9 -57 -15.5t-63 -6.5zM432 11q70 0 131.5 26t108 72.5t73.5 108t27 132.5q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5 t-71.5 -109.5t-25.5 -129.5q0 -70 26 -131.5t72.5 -108t108 -72.5t131.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EB",
    unicode: "\u01EB",
    horizAdvX: 503,
    d: "M343 -188q-22 0 -40 11t-29.5 30.5t-11.5 45.5q0 36 18.5 65.5t43.5 50.5l14 2q-21 -12 -40 -17.5t-47 -5.5q-55 0 -99.5 25.5t-71 69.5t-26.5 101q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -53 -25.5 -95.5t-66.5 -70.5q-36 -25 -56 -58 t-20 -66q0 -32 19.5 -51t43.5 -19q20 0 35.5 13t26.5 32l12 -9q-10 -22 -30 -38t-45 -16zM251 11q49 0 89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26t-63 -67t-23 -86q0 -50 23.5 -90.5t64 -64.5t89.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 911,
    d: "M249 -6q-54 0 -98.5 26t-70.5 70.5t-26 99.5q0 59 26.5 103t71 68.5t98.5 24.5q60 0 110.5 -35.5t72.5 -88.5l-4 -12v502h20v-752h-20v130l3 -16q-22 -53 -71.5 -86.5t-111.5 -33.5zM251 11q49 0 89.5 23t64.5 62t24 88v33q-7 42 -32.5 76.5t-63.5 55t-82 20.5 q-50 0 -90 -22.5t-63.5 -63t-23.5 -93.5q0 -49 24 -90t64 -65t89 -24zM630 360q-24 0 -37.5 8.5t-13.5 38.5v6h17v-12q0 -10 8 -16.5t25 -6.5h246l-258 -365l-5 5h258v-18h-286l260 366l6 -6h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM290 836q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM306 836q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5 q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5zM459 1072l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM207 503q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM223 503q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5 q-20 0 -34.5 -14.5t-14.5 -34.5zM347 784l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 923,
    d: "M463 702h367v-20h-347v-319h308v-19h-308v-324h361v-20h-381v702zM476 694q-2 -6 -4.5 -13t-4.5 -13l-421 -668h-22l439 702zM166 224h306v-18h-308zM726 874l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 759,
    d: "M202 -11q-52 0 -84.5 16.5t-48 41.5t-15.5 52q0 39 19.5 65t50 39t64.5 13q53 0 100.5 -25.5t74.5 -69.5l-6 -12q-34 42 -76.5 65.5t-90.5 23.5q-25 0 -51.5 -10t-44.5 -31t-18 -55q0 -39 30 -66.5t98 -27.5q19 0 46 4t53.5 14.5t42.5 29.5v127l18 -24l1 -109 q-21 -27 -54 -40t-63.5 -17t-45.5 -4zM347 184v79q0 43 -14.5 65t-38.5 30t-53 8q-39 0 -75.5 -14t-74.5 -53l-12 16q30 31 70.5 50.5t92.5 19.5q47 0 74 -14t39 -40.5t12 -61.5v-25zM543 -6q-55 0 -99.5 26t-70.5 70.5t-26 99.5q0 54 26 99t70.5 71.5t99.5 26.5 q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l333 134l-6 -10q-21 44 -59.5 76t-90.5 32q-50 0 -90 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t62 -66.5t93 -25.5q35 0 66.5 13t55.5 35l13 -14q-27 -23 -61.5 -37t-73.5 -14zM454 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 856,
    d: "M724 707l-592 -708l-12 11l593 708zM74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26 q71 0 133 26t109 72.5t74 108t27 132.5q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM532 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 481,
    d: "M403 369l-311 -371l-11 13l311 369zM54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5 t-64 65t-89 24.5q-51 0 -91 -26t-63 -67t-23 -86zM315 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0200",
    unicode: "\u0200",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM211 905h22l89 -133h-19zM308 905h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0201",
    unicode: "\u0201",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM128 614h22l89 -133h-19zM225 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0202",
    unicode: "\u0202",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM353 896q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0203",
    unicode: "\u0203",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM276 600q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0204",
    unicode: "\u0204",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM173 905h22l89 -133h-19zM270 905h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0205",
    unicode: "\u0205",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM90 614h22l89 -133h-19zM187 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0206",
    unicode: "\u0206",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM315 896q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0207",
    unicode: "\u0207",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM238 600q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0208",
    unicode: "\u0208",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM-15 905h22l89 -133h-19zM82 905h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0209",
    unicode: "\u0209",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM-40 613h22l89 -133h-19zM57 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020A",
    unicode: "\u020A",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM127 896q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020B",
    unicode: "\u020B",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM107 599q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020C",
    unicode: "\u020C",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM289 904h22l89 -133h-19zM386 904h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020D",
    unicode: "\u020D",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM108 614h22l89 -133h-19zM205 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020E",
    unicode: "\u020E",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM431 895q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020F",
    unicode: "\u020F",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM255 600q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0210",
    unicode: "\u0210",
    horizAdvX: 617,
    d: "M263 702q30 0 65.5 -10t67 -32t51.5 -57.5t20 -87.5q0 -38 -12 -73.5t-37.5 -63.5t-66.5 -44.5t-101 -16.5h-111v-317h-20v702h144zM247 336q60 0 98.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-125v-347h108zM339 335l201 -335h-23 l-201 335h23zM120 905h22l89 -133h-19zM217 905h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0211",
    unicode: "\u0211",
    horizAdvX: 321,
    d: "M109 378l3 -118l-2 11q11 36 36.5 61t59.5 38.5t71 14.5l-1 -18q-44 -1 -81 -20.5t-59 -52.5t-22 -76v-218h-20v378h15zM16 613h22l89 -133h-19zM113 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0212",
    unicode: "\u0212",
    horizAdvX: 617,
    d: "M263 702q30 0 65.5 -10t67 -32t51.5 -57.5t20 -87.5q0 -38 -12 -73.5t-37.5 -63.5t-66.5 -44.5t-101 -16.5h-111v-317h-20v702h144zM247 336q60 0 98.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-125v-347h108zM339 335l201 -335h-23 l-201 335h23zM262 896q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0213",
    unicode: "\u0213",
    horizAdvX: 321,
    d: "M109 378l3 -118l-2 11q11 36 36.5 61t59.5 38.5t71 14.5l-1 -18q-44 -1 -81 -20.5t-59 -52.5t-22 -76v-218h-20v378h15zM163 599q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5 t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0214",
    unicode: "\u0214",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM203 905h22l89 -133h-19zM300 905h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0215",
    unicode: "\u0215",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM99 614h22l89 -133h-19zM196 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0216",
    unicode: "\u0216",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM345 896q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5 t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0217",
    unicode: "\u0217",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM246 600q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5 t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 551,
    d: "M447 652q-28 12 -73 24.5t-92 12.5q-77 0 -123.5 -39.5t-46.5 -97.5q0 -44 25.5 -72.5t66 -48t87.5 -37.5q36 -13 71 -29t64 -38.5t46 -56t17 -81.5q0 -61 -28 -105t-76 -68t-108 -24q-57 0 -101 14.5t-73 31.5t-42 25l10 18q21 -15 53 -31.5t70.5 -28t78.5 -11.5 q49 0 94 19.5t73.5 59t28.5 99.5q0 59 -28 94.5t-71.5 57t-91.5 39.5q-35 12 -68 26.5t-59.5 33.5t-42.5 46t-16 64q0 47 25 82t67.5 55t95.5 20q38 0 88.5 -11t86.5 -28zM231 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 344,
    d: "M171 -8q-28 0 -61.5 10.5t-55.5 37.5l12 12q15 -19 43 -31t62 -12q24 0 46.5 8t37.5 27.5t15 52.5q0 30 -16 47.5t-40.5 27t-51.5 18.5q-37 13 -65 33t-28 64q0 32 14.5 53t38.5 32t50 11q23 0 52 -10t51 -34l-11 -13q-17 21 -44 30t-47 9q-18 0 -37.5 -7.5t-33.5 -24.5 t-14 -44q0 -24 12 -39.5t31.5 -25t41.5 -17.5q27 -10 54 -21t44.5 -30.5t17.5 -53.5q0 -33 -13.5 -57.5t-39.5 -38.5t-65 -14zM127 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 575,
    d: "M59 702h456v-19h-218v-683h-20v683h-218v19zM242 -184l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 304,
    d: "M133 543h20v-173h126v-17h-126v-353h-20v353h-88v17h88v173zM84 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022A",
    unicode: "\u022A",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM327 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM493 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5 t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0zM317 879h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022B",
    unicode: "\u022B",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM146 503q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM312 503q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0zM137 656h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022C",
    unicode: "\u022C",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM504 769q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32 q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11zM318 953h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022D",
    unicode: "\u022D",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM323 449q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z M137 666h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0230",
    unicode: "\u0230",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM410 784q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM317 878h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0231",
    unicode: "\u0231",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM229 498q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM137 651h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0232",
    unicode: "\u0232",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM207 774h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0233",
    unicode: "\u0233",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM101 508h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 216,
    d: "M64 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0259",
    unicode: "\u0259",
    horizAdvX: 467,
    d: "M216 384q56 0 100 -26t70.5 -70.5t26.5 -98.5q0 -55 -26.5 -100t-71 -71.5t-99.5 -26.5q-63 0 -106.5 36.5t-65.5 92.5l343 138l6 -17l-332 -134l6 10q20 -44 58.5 -76t91.5 -32q49 0 89 24t63.5 65t23.5 90q0 46 -22 87t-61.5 66.5t-93.5 25.5q-35 0 -66.5 -13 t-55.5 -34l-12 13q26 23 60.5 37t73.5 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0272",
    unicode: "\u0272",
    horizAdvX: 487,
    d: "M54 -181l-15 12q25 28 40 68t15 91v66h20v-63q0 -58 -16.5 -101t-43.5 -73zM109 378l4 -122l-3 14q16 54 62.5 84.5t103.5 30.5q53 0 84.5 -31.5t32.5 -80.5v-273h-20v271q-1 40 -26.5 67.5t-72.5 29.5q-42 0 -78.5 -18.5t-59 -52t-22.5 -78.5v-219h-20v378h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02BC",
    unicode: "\u02BC",
    horizAdvX: 167,
    d: "M132 551q-22 -52 -43 -103t-43 -103h-18q19 52 38 103t39 103h27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 448,
    d: "M345 508l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 443,
    d: "M117 631l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 396,
    d: "M83 513h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 348,
    d: "M175 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 187,
    d: "M66 505q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 417,
    d: "M162 473q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM178 473q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 270,
    d: "M144 -188q-28 0 -50 21t-22 56q0 38 29.5 70.5t68.5 52.5l14 -12q-45 -25 -69 -53t-24 -57q0 -28 17 -44t38 -16q19 0 35 13t26 32l13 -9q-10 -22 -30 -38t-46 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 389,
    d: "M266 447q-28 0 -45.5 14.5t-31.5 32.5q-14 15 -28 28t-35 13q-11 0 -24.5 -8t-23.5 -28.5t-12 -57.5l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q29 0 46 -15t31 -32q13 -16 28 -28.5t36 -12.5q14 0 26 8t20.5 28.5t10.5 58.5l16 -2q-1 -39 -11 -63.5t-26.5 -36t-35.5 -11.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 307,
    d: "M161 613l-92 -133h-19l89 133h22zM257 613l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    d: "M-12 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    d: "M159 613l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    d: "M345 508l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    d: "M265 448q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    d: "M83 508h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    d: "M175 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    d: "M66 505q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    d: "M82 502q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM248 502q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    d: "M137 534q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    d: "M163 473q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM179 473q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    d: "M161 613l-92 -133h-19l89 133h22zM257 613l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    d: "M116 631l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    d: "M-6 613h22l89 -133h-19zM91 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    d: "M173 658q35 0 62.5 -20.5t44.5 -56.5t18 -81h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 45 17.5 81t44 56.5t61.5 20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\u0312",
    d: "M124 630l10 -10q-28 -20 -39.5 -53t-5.5 -75h-22q-3 26 0.5 52t17 48.5t39.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    d: "M90 702q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    d: "M66 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0324",
    unicode: "\u0324",
    d: "M82 -89q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM248 -89q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    d: "M68 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    d: "M141 -181q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    d: "M145 -188q-28 0 -50 21t-22 56q0 38 29.5 70.5t68.5 52.5l14 -12q-45 -25 -69 -53t-24 -57q0 -28 17 -44t38 -16q19 0 35 13t26 32l13 -9q-10 -22 -30 -38t-46 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032E",
    unicode: "\u032E",
    d: "M175 -193q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0331",
    unicode: "\u0331",
    d: "M83 -76h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0335",
    unicode: "\u0335",
    d: "M85 259h232v-19h-232v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 624,
    d: "M19 0l315 734h5l311 -734h-631zM625 6l-296 706l13 -4l-301 -699l-7 10h597z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM94 358h19v-590h-19v590z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 283,
    d: "M5 322h273v-19h-39v-303h-19v303h-145v-303h-18v303h-52v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 984,
    d: "M54 701h22l258 -696l-7 2l151 417l10 -23l-158 -433zM369 701h20l263 -701l-11 4l268 697h21l-285 -733zM397 883h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 659,
    d: "M287 378l163 -367h-6l161 367h20l-179 -401l-121 275l-112 -275l-179 401h20l165 -369l-8 4l104 258l-48 107h20zM233 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 984,
    d: "M54 701h22l258 -696l-7 2l151 417l10 -23l-158 -433zM369 701h20l263 -701l-11 4l268 697h21l-285 -733zM596 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 659,
    d: "M287 378l163 -367h-6l161 367h20l-179 -401l-121 275l-112 -275l-179 401h20l165 -369l-8 4l104 258l-48 107h20zM404 594l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 984,
    d: "M54 701h22l258 -696l-7 2l151 417l10 -23l-158 -433zM369 701h20l263 -701l-11 4l268 697h21l-285 -733zM386 785q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM552 785q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5 t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 659,
    d: "M287 378l163 -367h-6l161 367h20l-179 -401l-121 275l-112 -275l-179 401h20l165 -369l-8 4l104 258l-48 107h20zM224 502q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM390 502q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5 t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 837,
    d: "M580 -8q-63 0 -107.5 15t-71.5 31l8 17q34 -19 78 -32t94 -13q33 0 70 16t62.5 46.5t25.5 74.5q0 39 -22.5 64.5t-57 44.5t-71.5 41q-43 21 -82.5 46t-64 58.5t-24.5 78.5q0 38 16.5 74t53 60.5t96.5 27.5q37 0 55.5 -9t32.5 -16l-7 -7q-44 39 -107.5 61.5t-127.5 22.5 q-87 0 -152.5 -37t-101.5 -115t-36 -199v-343h-20v347q0 108 32 190t100 128.5t176 46.5q61 0 114.5 -16.5t94 -42t65.5 -53.5l-10 -14q-9 6 -37 22.5t-70 16.5q-39 0 -72.5 -18.5t-53.5 -49.5t-20 -70q0 -44 23.5 -74.5t60.5 -54t79 -45.5q29 -16 57.5 -31.5t51 -33.5 t36 -42t13.5 -57q0 -43 -23 -78.5t-63 -57t-93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM332 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM249 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM361 742q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM272 441q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM465 792l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM563 1010l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM383 467l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM481 685l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM460 785l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM128 1019h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM378 460l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM46 694h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM461 793l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM455 882q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11 q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM379 468l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM373 557q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5 t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM466 773l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM422 943q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63 t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM384 449l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM340 619q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5 q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM332 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM469 768l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM249 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16zM387 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM357 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM457 1086l-92 -133 h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM268 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM335 770l-92 -133h-19l89 133h22z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM357 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM258 1096h22l89 -133 h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM268 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM164 761h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM357 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM359 953q23 19 39 35 t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM268 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM261 611q23 19 39 35t16 37 q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM357 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM424 981q-28 0 -45 14 t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM268 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM350 661q-27 0 -44.5 14.5 t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    horizAdvX: 709,
    d: "M63 0l291 734h2l291 -734h-22l-276 701l13 3l-279 -704h-20zM184 281h343l2 -18h-347zM332 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM357 756q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70 t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 542,
    d: "M249 -6q-54 0 -98 26t-70.5 70t-26.5 99q0 63 27 107t71.5 67t99.5 23q59 0 107.5 -33.5t70.5 -86.5l-2 -13l5 125h15v-378h-19v129l3 -14q-10 -26 -28 -48t-42 -38.5t-52.5 -25.5t-60.5 -9zM251 11q49 0 89 22t64 60.5t25 87.5v41q-8 41 -33.5 74t-63 53t-81.5 20 q-49 0 -89.5 -22t-64 -62.5t-23.5 -94.5q0 -50 24 -90.5t64 -64.5t89 -24zM249 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16zM268 462q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5 t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM294 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM211 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM322 741q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM234 441q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM388 769q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2 q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM305 449q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5 t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM426 791l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM524 1009l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM344 467l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM442 685l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM422 784l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM90 1018h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM340 460l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM8 694h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM423 792l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM417 881q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5 t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM341 468l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM335 557q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM428 773l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM384 943q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5 q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM346 449l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM302 619q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28 t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 631,
    d: "M119 702h419v-19h-399v-319h360v-19h-360v-326h413v-19h-433v702zM294 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM431 767l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    horizAdvX: 467,
    d: "M251 -6q-55 0 -99.5 26t-71 70.5t-26.5 99.5q0 54 26.5 99t71 71.5t99.5 26.5q63 0 106.5 -36.5t65.5 -91.5l-343 -139l-6 17l332 134l-5 -10q-21 44 -59.5 76t-91.5 32q-49 0 -89 -24t-63.5 -65t-23.5 -90q0 -46 22 -87t61.5 -66.5t93.5 -25.5q35 0 66.5 13t55.5 35 l13 -14q-27 -23 -61.5 -37t-73.5 -14zM211 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16zM349 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM135 741q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM103 440q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 258,
    d: "M119 702h20v-702h-20v702zM106 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM82 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM81 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM410 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM229 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM439 740q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45 t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM251 441q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM543 790l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM641 1008l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM362 467l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM460 685l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM538 783l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM206 1017h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM357 460l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM25 694h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM539 791l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM533 880q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8 q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM359 468l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM353 557q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM544 772l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM500 942q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58 l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM363 449l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM319 619q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12 q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM410 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM547 767l-119 137l13 1l-120 -138h-21l133 152h1 l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM229 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16zM366 480l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM505 702q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM537 873l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM311 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM326 595l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM505 702q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM338 883h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM311 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM155 614h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM505 702q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM439 740q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8 q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM311 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM251 441q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM505 702q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM504 769q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5 t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 503,
    d: "M322 448q-27 0 -44 14.5t-32 31.5q-13 15 -27 28t-34 13q-12 0 -25 -8t-23 -28t-11 -57l-16 2q1 38 12 62t27.5 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -15 27.5 -27.5t35.5 -12.5q20 0 36.5 18.5t19.5 74.5l16 -2q-1 -38 -11 -62t-26 -35.5t-36 -11.5zM54 190 q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26t-63 -67 t-23 -86zM311 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 865,
    d: "M74 350q0 74 28 139.5t77 115t114 77.5t139 28t139 -28t114.5 -77.5t78 -115t28.5 -139.5t-28.5 -139t-78 -114t-114.5 -77t-139 -28t-139 26.5t-114 74.5t-77 113.5t-28 143.5zM94 349q0 -70 26 -131.5t72 -108t107 -72.5t130 -26q71 0 133 26t109 72.5t74 108t27 132.5 q0 70 -27 131.5t-73.5 108.5t-108 74t-131.5 27q-72 0 -133.5 -27.5t-107.5 -75.5t-71.5 -109.5t-25.5 -129.5zM505 702q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM410 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5 q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 503,
    d: "M54 190q0 54 26.5 99t71 71.5t99.5 26.5t100 -26.5t71.5 -71.5t26.5 -99q0 -55 -26.5 -99.5t-71.5 -70.5t-100 -26t-99.5 25.5t-71 69.5t-26.5 101zM74 190q0 -50 23.5 -90.5t64 -64.5t89.5 -24t89 24t64 64.5t24 90.5q0 49 -24 89.5t-64 65t-89 24.5q-51 0 -91 -26 t-63 -67t-23 -86zM311 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM229 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM324 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5 q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM221 -100q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7 t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM353 741q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5 l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    horizAdvX: 487,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM243 441q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8 q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM562 698q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM450 874 l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 491,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM379 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM318 595 l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM562 698q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM251 884 h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 491,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM379 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM147 614h22 l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM562 698q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM353 741 q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 491,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM379 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM243 441 q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM562 698q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM418 769 q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 491,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM379 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM314 449 q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 693,
    d: "M138 230q0 -70 27 -119t74 -74.5t107 -25.5t107.5 25.5t74.5 74.5t27 119v472h20v-474q0 -77 -30.5 -129.5t-82 -79.5t-116.5 -27v0q-65 0 -116.5 27t-81.5 79.5t-30 129.5v474h20v-472zM562 698q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16zM324 -78 q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 491,
    d: "M211 -8q-53 0 -84 31.5t-33 81.5v273h20v-270q1 -41 26.5 -68.5t74.5 -29.5q40 0 76.5 19.5t59 53.5t22.5 77v218h20v-378h-17l-2 116l3 -9q-9 -32 -34 -58t-60 -41.5t-72 -15.5zM379 377q51 0 76 21.5t26 83.5h18q-1 -54 -16 -79.5t-42 -33.5t-62 -8v16zM221 -100 q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM227 883h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM119 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF4",
    unicode: "\u1EF4",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM299 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF5",
    unicode: "\u1EF5",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM305 -101q0 9 7 15.5t16 6.5t15.5 -6.5t6.5 -15.5q0 -10 -6.5 -16.5t-15.5 -6.5t-16 7t-7 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM329 740q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM215 440q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF8",
    unicode: "\u1EF8",
    horizAdvX: 643,
    d: "M312 261l-263 441h24l254 -425l-9 -1l253 426h23l-262 -441v-261h-20v261zM394 768q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75 l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF9",
    unicode: "\u1EF9",
    horizAdvX: 431,
    d: "M130 -181l245 559h22l-243 -559h-24zM210 -5l-176 383h21l171 -371zM287 448q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5 t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 510,
    d: "M100 197h301v-19h-301v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 701,
    d: "M99 197h503v-19h-503v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 165,
    d: "M106 713l9 -19q-22 -29 -31 -57.5t-3 -57.5l-23 -7q-5 27 -1 52.5t16.5 48t32.5 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 166,
    d: "M66 572l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 166,
    d: "M66 -104l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 232,
    d: "M220 713l9 -19q-22 -29 -31 -57.5t-3 -57.5l-23 -7q-5 27 -1 52.5t16.5 48t32.5 40.5zM119 713l9 -19q-22 -29 -31 -57.5t-3 -57.5l-23 -7q-5 27 -1 52.5t16.5 48t32.5 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 220,
    d: "M66 572l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0zM145 572l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 252,
    d: "M66 -118l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0zM145 -118l-9 18q21 20 30.5 50t3.5 65l23 7q5 -27 1 -52.5t-16.5 -48t-32.5 -39.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 300,
    d: "M56 440h188v-19h-188v19zM141 574h19v-505h-19v505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 312,
    d: "M57 295h196v-19h-196v19zM66 440h187v-19h-187v19zM150 574h19v-505h-19v505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 479,
    d: "M170 300q0 20 9.5 36t25 25.5t34.5 9.5q20 0 36 -9.5t25.5 -25.5t9.5 -36q0 -19 -9.5 -34.5t-25.5 -25t-36 -9.5q-19 0 -34.5 9.5t-25 25t-9.5 34.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 492,
    d: "M64 22q0 10 6.5 16.5t15.5 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM228 22q0 10 6.5 16.5t15.5 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM392 22q0 10 6.5 16.5t15.5 6.5t15.5 -6.5t6.5 -16.5 q0 -9 -6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1003,
    d: "M219 223q-31 0 -56.5 16.5t-40.5 48.5t-15 77q0 44 15 75.5t40.5 48t56.5 16.5t56.5 -16.5t40.5 -48t15 -75.5q0 -46 -15.5 -77.5t-41 -48t-55.5 -16.5zM126 364q0 -60 27 -92t66 -32t66 32t27 92q0 57 -27 90.5t-66 33.5t-66 -31t-27 -93zM527 3q-31 0 -56.5 16.5 t-40.5 48t-15 76.5q0 44 15 75.5t40.5 48t56.5 16.5t56.5 -16.5t40.5 -48t15 -75.5q0 -46 -15.5 -77.5t-41 -47.5t-55.5 -16zM434 143q0 -59 27 -91.5t66 -32.5t66.5 32.5t27.5 91.5q0 57 -27.5 90.5t-66.5 33.5t-66 -31t-27 -93zM533 508l-306 -508h-22l307 508h21zM803 3 q-31 0 -56.5 16.5t-40.5 48t-15 76.5q0 44 15 75.5t40.5 48t56.5 16.5t56.5 -16.5t40.5 -48t15 -75.5q0 -46 -15.5 -77.5t-41 -47.5t-55.5 -16zM709 143q0 -59 27.5 -91.5t66.5 -32.5t66 32.5t27 91.5q0 57 -27 90.5t-66 33.5t-66.5 -31t-27.5 -93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 391,
    d: "M113 239q13 13 27.5 26.5t29.5 27.5l30 28t30 27.5t29.5 27t27.5 26.5v-22l-34.5 -34.5l-35.5 -35.5t-35.5 -36t-34.5 -35q17 -17 34.5 -35t35.5 -36t35.5 -36t34.5 -36v-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 390,
    d: "M290 239q-14 13 -28 26.5t-29 27.5l-30 28t-30 27.5t-29.5 27t-28.5 26.5v-22l34.5 -34.5l35.5 -35.5t35.5 -36t34.5 -35q-17 -17 -34.5 -35t-35.5 -36t-35.5 -36t-34.5 -36v-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 534,
    d: "M449 665l-406 -665h-21l406 665h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2074",
    unicode: "\u2074",
    horizAdvX: 351,
    d: "M263 471v-15h-218l-1 9l174 196h8v-314h-19v290l5 -8l-147 -164l-5 6h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 690,
    d: "M501 738l-280 -761h-19l280 761h19zM622 740l-280 -761h-19l280 761h19zM616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17 q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 604,
    d: "M119 702h379v-19h-359v-330h320v-19h-320v-334h-20v702zM36 174h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 575,
    d: "M277 333v-19h-215v19h215zM277 220v-19h-215v19h215zM128 503q0 46 20 76t57 45t85 15q67 0 103 -25t56 -65l-15 -9q-12 22 -25 37.5t-29 24.5t-38 13t-52 4q-55 0 -86 -16t-44 -42t-13 -57v-353v-37q0 -13 -0.5 -27t-3 -26.5t-7 -23.5t-11.5 -17v0h243q58 0 83.5 10.5 t25.5 40.5v56h19v-39q0 -17 -2 -32.5t-12.5 -28t-35 -20t-69.5 -7.5h-345v20h44q23 0 34 13t14.5 45t3.5 88v337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 813,
    d: "M413 347h377v-17h-377v17zM413 330h-398v17h398v-17zM693 -13l-560 680l6 9v-676h-20v713h1l565 -688l-11 3v674h20v-715h-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "peseta",
    unicode: "\u20A7",
    horizAdvX: 542,
    d: "M457 515h75v-18h-75v18zM124 497h-80v18h80v-18zM265 702q58 0 103.5 -20t71.5 -61.5t26 -105.5q0 -38 -12.5 -73.5t-38.5 -63.5t-67 -44.5t-98 -16.5h-111v-317h-20v702h146zM250 336q58 0 96.5 18t60 46t31 59t9.5 58q0 40 -13.5 71t-37.5 52t-58 32t-74 11h-125v-347 h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 984,
    d: "M65 416h893v-18h-893v18zM54 701h22l258 -696l-7 2l151 417l10 -23l-158 -433zM369 701h20l263 -701l-11 4l268 697h21l-285 -733z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 602,
    d: "M331 670h205v-17h-205v17zM90 17h466v-17h-466v17zM288 106q-54 0 -98 26t-70 70.5t-26 99.5q0 59 26.5 103.5t70.5 69t98 24.5q60 0 110.5 -36t72.5 -89l-4 -11v408h19v-659h-19v130l2 -16q-21 -53 -70.5 -86.5t-111.5 -33.5zM290 124q49 0 89 22.5t64 61.5t25 88v33 q-8 42 -33.5 76.5t-63 55t-81.5 20.5q-50 0 -90 -22.5t-63.5 -63t-23.5 -93.5q0 -49 24 -89.5t64 -64.5t89 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 723,
    d: "M74 398h330v-19h-330v19zM75 290h329v-19h-329v19zM648 43q-26 -15 -55 -26.5t-62 -18t-70 -6.5q-80 0 -145 28t-112 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t113.5 77.5t139.5 28q51 0 97.5 -13.5t87.5 -37.5l-11 -17q-37 23 -82 36t-92 13q-70 0 -131 -26.5 t-107.5 -74t-72.5 -110t-26 -134.5q0 -67 23.5 -128t67.5 -107.5t105.5 -73t137.5 -26.5q50 0 94 13.5t82 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 642,
    d: "M35 420h491v-19h-491v19zM140 365l-1 -34l-3 3l384 368h26l-291 -279l334 -423h-26l-323 410l-101 -96l1 -314h-20v702h20v-337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 580,
    d: "M468 588h103v-18h-103v18zM469 457h102v-18h-102v18zM155 439h-115v18h115v-18zM155 570h-115v18h115v-18zM290 702q58 0 103.5 -20t71.5 -61.5t26 -105.5q0 -38 -12.5 -73.5t-38.5 -63.5t-67 -44.5t-98 -16.5h-111v-317h-20v702h146zM275 336q58 0 96.5 18t60 46t31 59 t9.5 58q0 40 -13.5 71t-37.5 52t-58 32t-74 11h-125v-347h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    horizAdvX: 735,
    d: "M637 43q-20 -11 -44.5 -20.5t-52 -16.5t-55 -10.5t-53.5 -3.5q-81 0 -147.5 27.5t-113.5 76.5t-72 114t-25 139q0 75 28 140.5t77 115t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-25 15 -53.5 26t-59 17t-61.5 6q-71 0 -132.5 -27t-108 -74t-72.5 -109 t-26 -132q0 -71 23.5 -132t67.5 -107.5t106 -72.5t139 -26q45 0 97 11.5t90 33.5v229h-170v19h190v-261zM393 783h19v-933h-19v933z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B5",
    unicode: "\u20B5",
    horizAdvX: 690,
    d: "M616 43q-26 -15 -55.5 -26.5t-62.5 -18t-69 -6.5q-80 0 -145.5 28t-112.5 77t-72 113.5t-25 136.5q0 76 27.5 142t76.5 115.5t114 77.5t139 28q51 0 97.5 -13.5t87.5 -37.5l-10 -17q-38 23 -82.5 36t-92.5 13q-69 0 -130.5 -26.5t-107.5 -74t-72.5 -110t-26.5 -134.5 q0 -67 23.5 -128t67.5 -107.5t105.5 -73t138.5 -26.5q49 0 93 13.5t82 35.5zM395 792h19v-933h-19v933z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 587,
    d: "M127 317v19h90q59 0 97.5 16t60.5 42t31.5 57.5t9.5 62.5q0 37 -14.5 68.5t-39.5 54t-58 34.5t-71 12h-106v19h382v-19h-226l-51 15q31 0 66 -9.5t66.5 -30.5t51.5 -56t20 -87q0 -38 -11.5 -73.5t-37 -63.5t-67 -44.5t-100.5 -16.5h-93zM486 0l-201 335h23l201 -335h-23z M122 492v18h401v-18h-401z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 619,
    d: "M544 314q1 -8 1 -16v-16q0 -79 -28 -133t-76.5 -87t-112.5 -47.5t-136 -14.5h-19v702h19v-693v10q67 0 127 13t106.5 43t73 81t26.5 126v14t-1 14zM434 360l8 -13l-375 -209l-8 13zM408 487l8 -13l-374 -207l-8 13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 694,
    d: "M340 831h18v-831h-18v831zM556 464q0 70 -27 119t-74 74.5t-108 25.5q-60 0 -107 -25.5t-74 -74.5t-27 -119v-472h-20v474q0 77 30 129.5t82 79.5t116 27v0q66 0 117.5 -27t81 -79.5t29.5 -129.5v-474h-19v472z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 555,
    d: "M40 180h247v-19h-247v19zM40 335h123v-19h-123v19zM290 702q58 0 103.5 -20t71.5 -61.5t26 -105.5q0 -38 -12.5 -73.5t-38.5 -63.5t-67 -44.5t-98 -16.5h-111v-317h-20v702h146zM275 336q58 0 96.5 18t60 46t31 59t9.5 58q0 40 -13.5 71t-37.5 52t-58 32t-74 11h-125 v-347h111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 1259,
    d: "M832 236h367v-19h-367v19zM693 -13l-560 679l5 10l1 -676h-20v713h1l565 -686l-10 1v674h19v-715h-1zM810 500q0 55 26 99.5t70.5 71.5t99.5 27t100 -27t71.5 -71.5t26.5 -99.5t-26.5 -99t-71.5 -70.5t-100 -26.5t-99.5 25.5t-70.5 70t-26 100.5zM829 500q0 -50 24 -90 t64 -64t89 -24t89.5 24t64.5 64t24 90q0 49 -24 90t-64.5 65t-89.5 24q-51 0 -91 -26t-63 -67t-23 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 563,
    d: "M478 676l11 -1l-116 -155l-114 155l10 1v-236h-16v270l123 -165h-5l123 165v-270h-16v236zM50 699h153v-16h-69v-243h-17v243h-67v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2126",
    unicode: "\u2126",
    horizAdvX: 833,
    d: "M492 19q49 18 92.5 51.5t71.5 86t28 128.5q0 71 -18 124.5t-51.5 89t-79 53.5t-98.5 19q-54 0 -99.5 -17.5t-79.5 -52.5t-53 -88t-19 -123q-1 -77 28 -130.5t74.5 -87.5t93.5 -53v-16q-37 14 -69.5 32.5t-59.5 42.5t-46.5 55t-30 70t-10.5 87q0 49 14.5 101.5t47 97.5 t84 73t126.5 27q74 0 125 -28.5t82 -74.5t44.5 -99t13.5 -101t-10 -86.5t-29 -69.5t-45 -54.5t-58 -41.5t-69 -31v16zM166 19h216v-19h-216v19zM492 19h205v-19h-205v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2206",
    unicode: "\u2206",
    horizAdvX: 500,
    d: "M236 731l153 -447h-19l-134 392l-134 -392h-19l153 447v0zM97 301h281v-17h-281v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 542,
    d: "M201 751h185v-803h-19v784h-147v-784h-19v803z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 489,
    d: "M81 751h332l-15 -19h-292l108 -385l-108 -386h292l15 -19h-332l114 405z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 820,
    d: "M86 203h360v-18h-360v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 326,
    d: "M312 737q-70 -189 -139 -378t-139 -378h-19q70 189 139 378t139 378h19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 177,
    d: "M89 238q-19 0 -32 13t-13 32t13 31.5t32 12.5q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 521,
    d: "M467 600h19l-250 -542l-136 299h-89l1 17h100l124 -263z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 428,
    d: "M222 301q0 -20 -13 -34.5t-33.5 -22.5t-43.5 -8q-26 0 -44 9.5t-27 24.5t-9 31q0 15 9 30t27 24.5t44 9.5q23 0 43.5 -8t33.5 -22.5t13 -33.5v0zM205 301q0 19 13 33.5t33.5 22.5t44.5 8q26 0 42.5 -9.5t24.5 -24.5t8 -30q0 -16 -8 -31t-24.5 -24.5t-43.5 -9.5 q-23 0 -43.5 8t-33.5 22.5t-13 34.5v0zM205 300q0 21 -23.5 35t-49.5 14q-31 0 -45.5 -16.5t-14.5 -31.5t14.5 -32t45.5 -17q26 0 49.5 14t23.5 34v0zM222 300q0 -20 23.5 -34t49.5 -14q31 0 45.5 17t14.5 32t-14.5 31.5t-45.5 16.5q-26 0 -49.5 -14t-23.5 -35v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 311,
    d: "M180 728q-20 0 -31.5 -11t-16 -35.5t-4.5 -64.5v-614q0 -58 -6 -89.5t-17.5 -44.5t-28 -15t-36.5 -2h-39v19h56q21 0 32 11t15.5 35.5t4.5 64.5v647v0q0 45 7.5 69.5t20 34.5t28.5 12t33 2h38v-19h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 487,
    d: "M236 164q-28 0 -45.5 14.5t-31.5 32.5q-14 15 -28 28t-35 13q-11 0 -24.5 -8t-23.5 -28.5t-12 -57.5l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q29 0 46 -15t31 -32q13 -16 28 -28.5t36 -12.5q14 0 26 8t20.5 28.5t10.5 58.5l16 -2q-1 -39 -11 -63.5t-26.5 -36t-35.5 -11.5z M237 316q-28 0 -45.5 14.5t-31.5 32.5q-14 15 -28 28t-35 13q-11 0 -24.5 -8t-23.5 -28.5t-12 -57.5l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q29 0 46 -15t31 -32q13 -16 28 -28.5t36 -12.5q14 0 26 8t20.5 28.5t10.5 58.5l16 -2q-1 -39 -11 -63.5t-26.5 -36t-35.5 -11.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 709,
    d: "M550 511q-42 -50 -84.5 -101t-86 -103l-87 -104t-86 -103t-84.5 -101l-11 10q42 50 84.5 101t86 103l87 104t86.5 103t84 102zM100 360h507v-18h-507v18zM100 166h507v-18h-507v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 554,
    d: "M460 220l-439 253l439 253v-22l-402 -231l402 -231v0v-22zM60 112h363v-18h-363v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 554,
    d: "M62 726l438 -253l-438 -253v22l402 231l-402 231v22zM61 112h363v-18h-363v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 447,
    d: "M236 731l153 -337l-153 -336l-153 336zM236 678l-134 -284l134 -283l134 283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 208,
    d: "M94 378h20v-378h-20v378zM82 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_ij",
    horizAdvX: 1006,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM406 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2 q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM676 378h20v-378h-20v378zM664 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5zM854 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5 t-44 -72.5zM882 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_ij",
    horizAdvX: 715,
    d: "M115 0v357h-65v18h65v210q0 97 27.5 134.5t82.5 37.5q10 0 20 -2t20 -6l-9 -14q-5 3 -12.5 5t-17.5 2q-47 0 -69 -33.5t-22 -119.5v-214h130v-18h-130v-357h-20zM385 378h20v-378h-20v378zM373 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5 q-10 0 -16.5 6.5t-6.5 15.5zM563 -181l-15 12q25 28 40 68t15 91v388h20v-385q0 -58 -16 -101.5t-44 -72.5zM591 497q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.zero",
    horizAdvX: 617,
    d: "M308 -6q-67 0 -118 27.5t-85.5 74.5t-51.5 106.5t-17 123.5t17 123t51.5 105.5t85.5 73.5t118 27q68 0 119 -27t85 -74t51.5 -106t17.5 -122q0 -64 -17.5 -123.5t-51.5 -106.5t-85 -74.5t-119 -27.5zM308 13q71 -1 128 36.5t90.5 107.5t34.5 168q-1 97 -34.5 167 t-90.5 107.5t-128 36.5q-70 1 -127 -36.5t-90.5 -107.5t-34.5 -167q1 -98 34.5 -168t90.5 -107.5t127 -36.5zM291 323q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 164,
    d: "M71 361q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 164,
    d: "M71 280q0 10 7 16.5t16 6.5t15.5 -6.5t6.5 -16.5q0 -9 -6.5 -15.5t-15.5 -6.5t-16 6.5t-7 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.case",
    d: "M82 642q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM248 642q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307.case",
    d: "M65 657q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb.case",
    d: "M-12 686h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb.case",
    d: "M159 617l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B.case",
    d: "M161 613l-92 -133h-19l89 133h22zM257 613l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302.case",
    d: "M345 508l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.case",
    d: "M117 631l119 -137l-13 -1l120 138h21l-133 -151h-1l-134 151h21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306.case",
    d: "M175 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A.case",
    d: "M162 550q0 28 18.5 46.5t46.5 18.5t46.5 -18.5t18.5 -46.5t-18.5 -46t-46.5 -18t-46.5 18t-18.5 46zM178 550q0 -19 14.5 -33.5t34.5 -14.5q19 0 33.5 14.5t14.5 33.5q0 20 -14.5 34.5t-33.5 14.5q-20 0 -34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb.case",
    d: "M266 597q-28 0 -45 14t-32 32q-13 15 -27 28t-35 13q-11 0 -24 -8t-23 -28.5t-12 -57.5l-16 2q1 39 12 63t28 35.5t35 11.5q28 0 45 -15t31 -32q13 -16 27.5 -28.5t35.5 -12.5t37.5 19t19.5 75l16 -2q-1 -39 -11 -63t-26.5 -35t-35.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304.case",
    d: "M84 514h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb.case",
    d: "M137 534q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F.case",
    d: "M-6 613h22l89 -133h-19zM91 613h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311.case",
    d: "M259 630q35 0 62.5 -21t44.5 -56.5t18 -81.5h-16q-2 38 -16.5 70t-38.5 51.5t-54 19.5t-53.5 -19.5t-37 -51.5t-14.5 -70h-18q1 46 17.5 81.5t44 56.5t61.5 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B.case",
    d: "M50 486q52 0 77 26t26 92h17q0 -59 -15.5 -87.5t-42 -37.5t-62.5 -9v16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb.case",
    d: "M66 -78q0 9 6.5 15.5t16.5 6.5q9 0 15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5q-10 0 -16.5 6.5t-6.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0324.case",
    d: "M82 -87q0 9 6.5 15.5t15.5 6.5t15.5 -6.5t6.5 -15.5t-6.5 -15.5t-15.5 -6.5t-15.5 6.5t-6.5 15.5v0zM248 -87q0 9 6.5 15.5t16.5 6.5q8 0 15 -6.5t7 -15.5t-7 -15.5t-15 -6.5q-10 0 -16.5 6.5t-6.5 15.5v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326.case",
    d: "M68 -183l-10 9q28 20 39 53t6 76h22q2 -26 -1 -52.5t-16.5 -49t-39.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327.case",
    d: "M141 -181q12 -11 31 -18.5t46 -7.5q41 0 65 15.5t24 45.5q0 27 -20 45.5t-62 18.5q-17 0 -39 -4.5t-34 -10.5l-14 13l73 89l16 -9l-68 -84l-15 4q11 7 35.5 13t46.5 6q49 0 75.5 -21t26.5 -60q0 -26 -14.5 -43t-39 -25.5t-54.5 -8.5q-28 0 -51 7.5t-38 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328.case",
    d: "M145 -188q-28 0 -50 21t-22 56q0 38 29.5 70.5t68.5 52.5l14 -12q-45 -25 -69 -53t-24 -57q0 -28 17 -44t38 -16q19 0 35 13t26 32l13 -9q-10 -22 -30 -38t-46 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032E.case",
    d: "M175 -189q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0331.case",
    d: "M83 -98h231v-17h-231v17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060301",
    d: "M175 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM242 807l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060300",
    d: "M175 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM71 798h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060309",
    d: "M175 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM168 648q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11 q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060303",
    d: "M189 499q-35 0 -62.5 20.5t-44.5 56.5t-18 81h17q1 -38 15.5 -70t38.5 -51.5t54 -19.5t53.5 19.5t37 51.5t15.5 70h17q0 -45 -17 -81t-44.5 -56.5t-61.5 -20.5zM271 698q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2 q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020301",
    d: "M345 466l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM443 684l-92 -133h-19l89 133h22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020300",
    d: "M372 459l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM40 693h22l89 -133h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020309",
    d: "M344 467l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM338 556q23 19 39 35t16 37q0 20 -10 33.5t-32 13.5q-19 0 -31 -8.5t-28 -29.5l-11 8q15 24 32 35t39 11q15 0 27.5 -6t21 -19.5t8.5 -36.5q0 -27 -18 -45t-43 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020303",
    d: "M347 467l-119 137l13 1l-120 -138h-21l133 152h1l134 -152h-21zM303 637q-27 0 -44.5 14.5t-31.5 31.5q-14 15 -28 28t-34 13q-12 0 -25 -8t-23 -28t-12 -58l-16 2q1 39 12.5 63t28 35.5t34.5 11.5q28 0 45 -15t31 -32q13 -16 28 -28t36 -12q20 0 36.5 18.5t19.5 74.5 l16 -1q-1 -39 -11 -63.5t-26 -35.5t-36 -11z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF8",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF6",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF4",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF2",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E84",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E82",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1E80",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0232",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u021A",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0178",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0176",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0174",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0164",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0162",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDD",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Y",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u20AB",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "O",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "G",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAE",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA8",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0202",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0200",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "j",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "i",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "f",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1EF8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1EF6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1EF4",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1EF2",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1E84",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1E82",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u1E80",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0232",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0178",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0176",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0174",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\xDD",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "Y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "W",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EF7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EF5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EF3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EDE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EDC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1EDA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ED8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ED6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ED4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ED2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ED0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ECE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u1ECC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0233",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0230",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u022C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u022A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u020E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u020C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01EA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01E6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u01A0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0177",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0150",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u014E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u014C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0122",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0120",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u011E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u011C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u010C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u010A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0108",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0106",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xFF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xFD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "y",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1EE2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1EE0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1EDE",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1EDC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1EDA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ED8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ED6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ED4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ED2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ED0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ECE",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1ECC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1E84",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1E82",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u1E80",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0230",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u022C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u022A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u020E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u020C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u01EA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u01E6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u01A0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0174",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0152",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0150",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u014E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u014C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0122",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0120",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u011E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u011C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u010C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u010A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0108",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0106",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xC7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "O",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "G",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Y",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "T",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAE",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA8",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0202",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0200",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EE0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EDE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EDC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1EDA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ED8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ED6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ED4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ED2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ED0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ECE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u1ECC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0230",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u022C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u022A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u020E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u020C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u01EA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u01E6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u01A0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0150",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u014E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u014C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0122",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0120",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u011E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u011C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u010C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u010A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0108",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0106",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2026",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EE2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EE0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EDE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EDC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1EDA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ED8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ED6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ED4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ED2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ED0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ECE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u1ECC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0230",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u022C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u022A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u020E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u020C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u01EA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u01E6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u01A0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0152",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0150",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u014E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u014C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0122",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0120",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u011E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u011C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u010C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u010A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0108",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0106",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "z",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "O",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "G",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EB6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EB4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EB2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EB0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EAE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EAC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EAA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EA8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EA4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EA2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u1EA0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0202",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0200",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u01FA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0104",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0102",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0100",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xC0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "i",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EE2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EE0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EDE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EDC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EDA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ED8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ED6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ED4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ED2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ED0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ECE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1ECC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0230",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u022C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u022A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u020E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u020C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01EA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01E6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01A0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0150",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0122",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0120",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0108",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EE2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EE0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EDE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EDC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EDA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ED8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ED6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ED4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ED2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ED0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ECE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1ECC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EB6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EB4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EB2",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EB0",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EAE",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EAC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EAA",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EA8",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EA6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EA4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EA2",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EA0",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0230",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u022C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u022A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u020E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u020C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0202",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0200",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u01FA",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u01EA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u01E6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u01A0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0152",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0150",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u014E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u014C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0122",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0120",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u011E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u011C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u010C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u010A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0108",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0106",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0104",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0102",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0100",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "s",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "S",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "O",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "G",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "w",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EE3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EE1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EDD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EDB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ED9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ED7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ED5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ED3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ED1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ECF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1ECD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EC7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EC5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EC3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EC1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EBF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EBD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EBB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EB9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EB5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EB3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EB1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EAF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EAD",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EAB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EA9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EA7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EA5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EA3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EA1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0259",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0231",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u022D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u022B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u020F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u020D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0207",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0205",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0203",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0201",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u01FB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u01EB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u01E7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u01C6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u01A1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0153",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0151",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u014F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u014D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0123",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0121",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u011F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u011D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u011B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0119",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0117",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0115",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0113",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0111",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u010F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u010D",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u010B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0109",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0107",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0105",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0103",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0101",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "o",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "g",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "e",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "c",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "a",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1EF9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1EF7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1EF5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1EF3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1E85",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1E83",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u1E81",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u0233",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u0177",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u0175",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xFF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xFD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "w",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "a",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "\u0259",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "z",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "i",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "z",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "i",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "i",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "i",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01A0",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01A0",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01A0",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0200",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0200",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0202",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0202",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "z",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "i",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0232",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0232",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0232",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "i",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "i",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "i",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "U",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDA",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDA",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDA",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDC",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDC",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDC",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDE",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDE",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EDE",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE0",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE0",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE0",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE2",
    u2: "Y",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE2",
    u2: "X",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE2",
    u2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF4",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF4",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF4",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xC6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "p",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Ohorn,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Ohorn,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Ohorn,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Ohorn,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Ohorn,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    g2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Ohorn,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    g2: "X",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,ohorn,uni01EB,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,ohorn,uni01EB,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "m,n,r,u,ntilde,nacute,uni0146,ncaron",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "comma,period,ellipsis",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "m,n,r,u,ntilde,nacute,uni0146,ncaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "comma,period,ellipsis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "s",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,r,u,ntilde,nacute,uni0146,ncaron",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n,ntilde,nacute,uni0146,ncaron",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,r,u,ntilde,nacute,uni0146,ncaron",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,ellipsis",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE,Ohorn,Gcaron,uni01EA,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "v,y,yacute,ydieresis,ycircumflex,uni0233,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,r,u,ntilde,nacute,uni0146,ncaron",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,ellipsis",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,gcaron,uni01EB,aringacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EE1,uni1EE3",
    k: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJosefinSansVariableFontWght);
export default __webpack_public_path__ + "static/media/JosefinSansVariableFont_wght.9b127fa84e90fb67892d237b641b9c52.svg";
export { ForwardRef as ReactComponent };